import { useState, useRef, useEffect } from "react";
import "../assets/styles/editor.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faPause,
  faPlay,
  faTrash,
  faTimes,
  faPencilAlt,
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { createFFmpeg } from "@ffmpeg/ffmpeg";
import { FrameTime } from "./FrameTime";
import { SelectedTimeFrame } from "./SelectedTimeFrame";
import {
  frameViewColor,
  scameTimeMeasure,
} from "../assets/constants/constants";
import { TiExport } from "react-icons/ti";
import { FaKeyboard } from "react-icons/fa6";
import { FaCropAlt } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { MdFilterListAlt } from "react-icons/md";
import { IoIosInformationCircle } from "react-icons/io";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { FaChartBar } from "react-icons/fa";
import { IoInformationCircleSharp } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";
import { IoIosSave } from "react-icons/io";
import { MdBackup } from "react-icons/md";
import { MdOutlineSettingsBackupRestore } from "react-icons/md";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { AlertMessageBox, triggerAlert } from "./AlertMessage";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import {
  Paper,
  Checkbox,
  FormControlLabel,
  Divider
} from "@mui/material";
import usePreventZoom from '../common_functions/usepreventzoom'
import ROISelector from "./ROISelector";
import Tooltip from '@mui/material/Tooltip';
import MeasurementsModal from "./MeasureModal";
import ExportChartData from "./ChartData";
import { download_meta_file, download_video_frames, get_collections_labelList, updateAccessKey, updateAllAccessKeys } from "../assets/constants/global_apis";
import { calculateBoxPercentage, calculateBoxFromPercentage, generateUniqueColors } from "../common_functions/video_annotator_functions";
import { GradientCircularProgress } from "./Loader";
import LabelDropdown from "./LabelsDropwDown";
import { SingleInputModal } from "./SingleInputModal";
const modalStyle = {
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  height: 200,
  pt: 2,
  paddingLeft: 0,
  paddingRight: 0,
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  backgroundColor: '#f5f5f5',
  padding: '25px'
};


const shortCutsList = [
  {
    key: 'delete',
    event: 'Deletes the selected sublabel timing'
  },
  {
    key: 'Cntrl + Scroll Up',
    event: 'Zooms in annotator label lines'
  },
  {
    key: 'Cntrl + Scroll Down',
    event: 'Zooms out annotator label lines'
  },
  {
    key: 'Cntrl + s',
    event: 'Saves the Annotation into File'
  },
  {
    key: 'Cntrl + +',
    event: 'Zoom In Time Frame'
  },
  {
    key: 'Cntrl + -',
    event: 'Zoom Out Time Frame'
  },
  {
    key: 'Cntrl + shift + -',
    event: 'Zoom Out completely'
  },
  {
    key: 'Cntrl + shift + +',
    event: 'Zoom In completely'
  },
  {
    key: 'Cntrl + z',
    event: 'Undo changes'
  },
  {
    key: 'Cntrl + shift + z',
    event: 'Redo changes'
  },
  {
    key: 'space',
    event: 'If player is focused it pauses and plays video'
  },
  {
    key: 'cntrl + right arrow',
    event: '10 seconds forward'
  },
  {
    key: 'cntrl + left arrow',
    event: '10 seconds backward'
  },
  {
    key: 'cntrl + shift + right arrow',
    event: 'Move forward labels frame by mentioned frames'
  },
  {
    key: 'cntrl + shift + left arrow',
    event: 'Move backward labels frame by mentioned frames'
  },
  {
    key: 'cntrl+ alphanumeric',
    event: 'adding first 29 labelsets to the timeline'
  },
  {
    key: 'cntrl+ `',
    event: 'Open labelset shortcut controller'
  },
  {
    key: 'cntrl + shift + f',
    event: 'Open frame value controller'
  }
]
const minFrameSpace = 3;

export const VideoAnnotator = ({
  videoUrl,
  timings,
  setTimings,
  annotationData,
  labelsLi,
  currentlabel,
  onchangeHandlerLabel,
  handleSubmit,
  handleSubmitBackup,
  videoFrameCount,
  roiList,
  setroiList,
  urlParams,
  addRoiCoordinates,
  updateRoiCoordinates,
  deleteRoiCoordinates,
  collectionLabelset,
  labelsetsAccessKeys,
  setLabelsetsAccessKeys,
  availableKeys,
  handleGetCollectionLabelsetDetails,
  setCollectionLabelSet
}) => {
  const [frameExport_progressPercent, setFrameExport_progressPercent] = useState(0);
  const [frameExport_statusMessage, setFrameExport_statusMessage] = useState("");

  const [isMuted, setIsMuted] = useState(false);
  const [openChartData, setOpenChartData] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [seekerBar, setSeekerBar] = useState(0);
  const playVideoRef = useRef();
  const roiDrawRef = useRef(null);
  const progressBarRef = useRef();
  const progressBarRef1 = useRef();
  const playBackBarRef = useRef();
  const controllerWrapperRef = useRef();
  const playBackBarRef1 = useRef();
  const scrollBarRef = useRef();
  const ffmpeg = useRef(null);
  const [videoTiming, setVideoTiming] = useState(0);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [frameInterval, setFrameInterval] = useState(5)
  const [frameIntervalControll, setFrameIntervalControll] = useState(5)
  const [arrowIntervalControll, setArrowIntervalControll] = useState(5)
  const [analyticData, setAnalyticData] = useState({
    mean: 0,
    median: 0,
    min: 0,
    max: 0
  })
  const [exportFrameLoader, setEportFrameLoader] = useState(false)
  const [maxAnnotated, setMaxAnnoatated] = useState(0);
  const [sublabelTimings, setsubLabelTimings] = useState(
    annotationData?.labels[0]?.sublabels
  );
  const [filteredSublabelTimings, setfilteredSublabelTimings] = useState(
    annotationData?.labels[0]?.sublabels.slice(0, annotationData?.labels[0]?.sublabels.length)
  );
  const [selectAll, setSelectAll] = useState(true);
  const [progressBarTimStmp, setprogressBarTimStmp] = useState(-1);
  const [hoverTimeLft, sethoverTimeLft] = useState(0);
  const [currentVideoPlayTime, setCurrentVideoPlayTime] = useState(0);
  const [selectedLabelTab, setselectedLabelTab] = useState({
    ...annotationData?.labels[0]?.sublabels[0]?.timings[0],
    accindex: 0,
    timingindx: 0,
    currentGrabbed: "end",
    frameLabel: {
      start: 0,
      end: 120,
      accindex: 0,
      timingindx: 0,
      currentGrabbed: "end",
    },
  });
  const [playbackLength, setplayBackLength] = useState(
    window.screen.availWidth * 0.8
  );
  const [labelContainerHeight, setLabelContainerHeight] = useState(
    window.screen.availHeight * 0.2
  );
  const [frames, setframes] = useState([]);
  const [isGetFrameChecked, setisGetFrameChecked] = useState(false);
  const [isFrameEnabled, setisFrameEnabled] = useState(true);
  const [timing1, settiming1] = useState([]);
  const [grabberColors, setgrabberColors] = useState([])
  const [timeEnd, setTimeEnd] = useState(0);
  const [openlabelSelector, setOpenlabelSelector] = useState(false);
  const [modalType, setmodalType] = useState('');
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [progressBarTime, setProgressBarTime] = useState(0);
  const [timingsList, setTimingsList] = useState([])
  const [history, setHistory] = useState([]);
  const [future, setFuture] = useState([]);
  const [updateHistoryRequired, setUpdateHistoryRequired] = useState(false);
  const [roiLabelModal, setRoiLabelModal] = useState(false);
  const [newROILabel, setNewROILabel] = useState('');
  const [alertMessage, setAlertMessage] = useState({
    Errortype: "Error",
    title: "",
    message: "",
  });
  const [currentPlayFrame, setcurrentPlayFrame] = useState({
    accindex: -1,
    timingindx: -1,
  });
  const [isLabelVideoPlayerOn, setisLabelVideoPlayerOn] = useState(false);
  const [editableInp, setEditableInp] = useState({
    accindex: -1,
    timingindx: -1,
    currentGrabbed: '',
    currentValue: ''
  });
  const [frameCount, setFrameCount] = useState(videoFrameCount);
  const [frameTimeLimit, setframeTimeLimit] = useState(parseFloat((1 / videoFrameCount).toFixed(10)));
  const [timeFrameLimit, settimeFrameLimit] = useState([]);
  const frameLabels = useRef("");
  let [digitslngth, setdigitslngth] = useState(String(parseFloat((1 / videoFrameCount).toFixed(10))).length);
  const firstDivRef = useRef();
  const secondDivRef = useRef();
  const [zoomAreaRatio, setZoomAreaRatio] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  });
  const [zoomArea, setZoomArea] = useState(null);
  const [buttonAction, setbuttonAction] = useState({
    event: '',
    eventMessage: ''
  })
  const hasUserInitiatedPlay = useRef(false);
  const [open, setOpen] = useState(false);
  const [visibleVideoDimensions, setVisibleVideoDimensions] = useState({
    width: 0,
    height: 0,
    videoWidth: 0,
    videoheight: 0
  })
  const [showCroppedVideo, setShowCroppedVideo] = useState(false);
  const [enableROI, setEnableROI] = useState(false);
  const [selecteROIindex, setSelecteROIindex] = useState(0);
  const [selectedEditableROIindex, setSelectedEditableROIindex] = useState(-1);
  const [measurements, setMeasurements] = useState({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    editable: false
  });
  const [contextMenu, setContextMenu] = useState({ start: 0, end: 0, accindex: -1, index: -1 });
  const [activeAction, setActiveAction] = useState("");
  const [timingInput, setTimingInput] = useState({ start: "", end: "" });
  const [copiedDuration, setCopiedDuration] = useState(0);
  const [enableLabelEdit, setEnableLabelEdit] = useState(false);

  useEffect(() => {
    let measurementValues = {};
    let zoomRatio = (enableROI ? { ...calculateBoxPercentage(visibleVideoDimensions.width, visibleVideoDimensions.height, zoomArea != null ? zoomArea.x : 0, zoomArea != null ? zoomArea.y : 0, zoomArea != null ? zoomArea.width : 0, zoomArea != null ? zoomArea.height : 0) } : { ...zoomAreaRatio });
    if (enableROI) {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: true }
    } else if (!enableROI && selecteROIindex != 0 && selectedEditableROIindex == -1) {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: false }
    } else if (!enableROI && selecteROIindex == 0 && selectedEditableROIindex != -1) {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: enableROI ? true : false }
    } else {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: false }
    }
    if (zoomArea == null && selecteROIindex == 0 && selectedEditableROIindex == -1) {
      setMeasurements({
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        editable: true
      });
    } else {
      setMeasurements(measurementValues)
    }
  }, [selecteROIindex, visibleVideoDimensions])
  const onchangeScroll = (e) => {
    e.stopPropagation();
    if (playbackLength - e?.deltaY > window.screen.availWidth * 0.76) {
      setplayBackLength((prevState) => prevState - e.deltaY);
    } else if (e?.deltaY < 0) {
      setplayBackLength((prevState) => prevState - e.deltaY);
    }
  };
  const handleKeyZoom = (e, isCompleteZoominAndOut) => {
    // Normalize key values
    const isPlus = e?.key === '+' || e?.key === '='; // Some layouts use '=' for +
    const isMinus = e.key === '-' || e.key === '_';

    if (isCompleteZoominAndOut) {
      if (isPlus || isMinus) {
        e.preventDefault();
        const widthToExpand = getWdithToExpand();
        isMinus ? setplayBackLength(window.screen.availWidth * 0.76) :
          setplayBackLength(widthToExpand);
      }
    } else if (isPlus || isMinus) {
      e.preventDefault();

      // Optional: Check for ctrlKey if you want Ctrl+Zoom only
      // if (!e.ctrlKey) return;

      const zoomDelta = isPlus ? -100 : 100;

      setplayBackLength((prevState) => {
        const newLength = prevState - zoomDelta;
        const minLength = window.screen.availWidth * 0.76;
        return newLength >= minLength ? newLength : prevState;
      });
    }
  };
  usePreventZoom(true, true, onchangeScroll, playbackLength);

  const handleScrollFirst = scroll => {
    if (secondDivRef?.current?.scrollTop && scroll?.target?.scrollTop) {
      secondDivRef.current.scrollTop = scroll.target.scrollTop;
    }
  };

  const handleScrollSecond = scroll => {
    if (firstDivRef?.current?.scrollTop && scroll?.target?.scrollTop) {
      firstDivRef.current.scrollTop = scroll.target.scrollTop;
    }
  };

  Number.prototype.round = function (places) {
    return +(Math.round(this + "e+" + places) + "e-" + places);
  }
  const handleSpeedChange = (event) => {
    const selectedRate = parseFloat(event.target.value);
    if (playVideoRef?.current) {
      playVideoRef.current.playbackRate = selectedRate == 3 ? selectedRate - 0.01 : selectedRate;
      setPlaybackRate(selectedRate);
    }
  };

  const openAlertPopup = () => {
    setShowAlertBox(true);
    setTimeout(function () {
      setShowAlertBox(false);
    }, 2000);
  };
  const handleOpenLabelSelector = () => setOpenlabelSelector(true);
  const handleCloseLabelSelector = () => setOpenlabelSelector(false);
  const handleOpenChartData = () => setOpenChartData(true);
  const handleCloseChartData = () => setOpenChartData(false);

  function storeFrame(video, context, canvas, resolve) {
    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    resolve(canvas.toDataURL());
  }

  // const getVideoFrame = async (video, context, canvas, time) => {
  //   return new Promise((resolve, reject) => {
  //     let eventCallback = () => {
  //       video.removeEventListener("seeked", eventCallback);
  //       storeFrame(video, context, canvas, resolve);
  //     };
  //     video.addEventListener("seeked", eventCallback);
  //     video.currentTime = time;
  //   });
  // };

  // async function getFrames(amount, type) {
  //   return new Promise((resolve, reject) => {
  //     let video_Url = videoUrl;
  //     let frames = [];
  //     let canvas = document.createElement("canvas");
  //     let context = canvas.getContext("2d");
  //     let duration;

  //     let video = document.createElement("video");
  //     video.preload = "autos";
  //     video.addEventListener("loadeddata", async function () {
  //       canvas.width = video.videoWidth;
  //       canvas.height = video.videoHeight;
  //       duration = selectedLabelTab.end;

  //       let totalFrames = amount;
  //       if (type === 0) {
  //         totalFrames = duration * amount;
  //       }

  //       for (
  //         let time = selectedLabelTab.start;
  //         time < duration;
  //         time += 1 / frameCount
  //       ) {
  //         frames.push({
  //           imgUrl: await getVideoFrame(video, context, canvas, time),
  //           time: time,
  //         });
  //       }
  //       resolve(frames);
  //     });
  //     video.src = video_Url;
  //     video.load();
  //   });
  // }

  const load = async () => {
    try {
      await ffmpeg.current.load();
    } catch (error) { }
  };

  useEffect(() => {
    ffmpeg.current = createFFmpeg({
      log: true,
      corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
    });
    load();
    const close = () => {
      setContextMenu(null);
    };
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);

  }, []);

  const handleTimingListUpdate = (sublabelTimingsObj) => {
    const timings = sublabelTimingsObj.map((sublabel, index) => {
      return sublabel.timings.map((item, index1) => {
        return {
          start: item.start,
          end: item.end
        };
      });
    });
    const timingsSorted = [...timingsList].sort((a, b) => a.end - b.end);
    setMaxAnnoatated(timingsSorted[timingsSorted.length - 1]?.end || 0);
    setTimingsList(timings.flat());
  }
  const updateSublabelTimingsHistory = (sublabelTimingsObj = []) => {
    const clone = JSON.parse(JSON.stringify(sublabelTimingsObj));

    setHistory((prev) => {
      const last = prev[prev.length - 1];
      const isSame = JSON.stringify(last) === JSON.stringify(clone);
      if (isSame) {
        return prev;
      }
      return [...prev, clone];
    });
  };

  const undo = () => {
    setUpdateHistoryRequired(true);
    if (history.length === 0) return;
    const previous = JSON.parse(JSON.stringify(history[history.length - 1]));
    setsubLabelTimings(previous);
    setHistory((prev) => {
      return prev.slice(0, prev.length - 1)
    });
    setFuture((f) => [structuredClone(sublabelTimings), ...f]);
  };

  const redo = () => {
    setUpdateHistoryRequired(true)
    if (future.length === 0) return;
    const next = JSON.parse(JSON.stringify(future[0]));
    setsubLabelTimings(next);

    setFuture((f) => f.slice(1));
    setHistory((prev) => [...prev, structuredClone(sublabelTimings)]);
  };


  const handleHistoryUpdate = (sublabelTimingsObj) => {
    const timings = sublabelTimingsObj.map((sublabel, index) => {
      return sublabel.timings.map((item, index1) => {
        return {
          start: item.start,
          end: item.end
        };
      });
    });
    const timingsSorted = [...timingsList].sort((a, b) => a.end - b.end);
    setMaxAnnoatated(timingsSorted[timingsSorted.length - 1]?.end || 0);
    setTimingsList(timings.flat());
  }

  useEffect(() => {
    if (annotationData?.labels[0]?.sublabels.length != sublabelTimings.length) {
      setfilteredSublabelTimings(sublabelTimings);
    }
    handleTimingListUpdate(sublabelTimings);
    !updateHistoryRequired && updateSublabelTimingsHistory(sublabelTimings);
    setUpdateHistoryRequired(false);

    const keyEventOperations = (event) => {
      const key = event.key;
      if (key === "Delete" && selectedLabelTab?.accindex != -1 && selectedLabelTab?.timingindx != -1) {
        let tmpSublabel = [...sublabelTimings];
        let timingsval = [...tmpSublabel[selectedLabelTab.accindex].timings],
          dta = [];
        for (let i = 0; i < timingsval.length; i++) {
          if (i != selectedLabelTab?.timingindx) {
            dta.push(timingsval[i]);
          }
        }
        tmpSublabel[selectedLabelTab.accindex].timings = dta;
        setselectedLabelTab({
          ...tmpSublabel[selectedLabelTab.accindex].timings[0],
          accindex: selectedLabelTab.accindex,
          timingindx: 0,
          currentGrabbed: "end",
          frameLabel: {
            start: 0,
            end: 120,
            accindex: selectedLabelTab.accindex,
            timingindx: 0,
            currentGrabbed: "end",
          },
        });
        setsubLabelTimings(tmpSublabel);
      }
      else if (event?.key === 's' && event?.ctrlKey) {
        event.preventDefault();
        handleSubmit(sublabelTimings);
      }
      else if ((event.key === '+' || event.key === '-' || event.key === '_' || event.key === '=') && event.ctrlKey && event.shiftKey) {
        event.preventDefault();
        handleKeyZoom(event, true);
      }
      else if (event.ctrlKey && event.key === '`') {
        event.preventDefault();
        console.log('Backquote detected, toggling label selector');
        setOpenlabelSelector(prev => !prev);
        setmodalType("labelsInfo");
      }
      else if ((event.key === '+' || event.key === '=') && event?.ctrlKey) {
        event.preventDefault();
        handleKeyZoom(event);
      } else if (event?.ctrlKey && availableKeys.includes(event.key)) {
        let labelsObject = [];
        if (collectionLabelset.length == 0 || Object.keys(labelsetsAccessKeys).length == 0) {
          let tmpAvailableKeys = [...availableKeys];
          get_collections_labelList(urlParams.collectionID).then((data) => {
            setCollectionLabelSet(data)
            let labelsetAccessKeys = {};
            data?.forEach((item, index) => {
              if (currentlabel == item.labelSetName) {
                item?.labels?.forEach((item1, index) => {
                  tmpAvailableKeys = tmpAvailableKeys.filter((key) => key != item1?.labelAccessKey);
                })
              }
            })
            data?.forEach((item, index) => {
              if (currentlabel == item.labelSetName) {
                item?.labels?.forEach((item1, index) => {
                  labelsetAccessKeys[item1.labelName] = {
                    'labelAccessKey': item1?.labelAccessKey ? item1.labelAccessKey : tmpAvailableKeys[0] ? tmpAvailableKeys[0] : null,
                    'enableEdit': false
                  };
                  if ((!item1?.labelAccessKey || item1?.labelAccessKey == '') && tmpAvailableKeys.length > 0) {
                    tmpAvailableKeys.shift();
                  }
                })
                setLabelsetsAccessKeys(labelsetAccessKeys);
              }
            })
            data.map((labelset, index) => {
              if (labelset?.labelSetName == currentlabel) {
                labelset.labels.forEach((label) => {
                  labelsObject.push({
                    ...label,
                    labelAccessKey: labelsetAccessKeys[label.labelName].labelAccessKey
                  })
                })
              }
            })
            const index = labelsObject.findIndex(
              (label) => label.labelAccessKey === event.key
            );
            if (index !== -1) {
              event.preventDefault();
              addExtramargins(index);
            }
          }).catch((error) => {
            console.error("Error fetching collection labels:", error);
          })
        } else {
          collectionLabelset.map((labelset, index) => {
            if (labelset?.labelSetName == currentlabel) {
              labelset.labels.forEach((label) => {
                labelsObject.push({
                  ...label,
                  labelAccessKey: labelsetsAccessKeys[label.labelName].labelAccessKey
                })
              })
            }
          })
          const index = labelsObject.findIndex(
            (label) => label.labelAccessKey === event.key
          );
          if (index !== -1) {
            event.preventDefault();
            addExtramargins(index);
          }
        }
      }
      // else if (event.ctrlKey && /^[1-9]$/.test(event.key)) {
      //   event.preventDefault();
      //   const index = parseInt(event.key, 10) - 1; // Convert '1' to 0, '2' to 1, ..., '9' to 8
      //   if (index < sublabelTimings.length) {
      //     addExtramargins(index);
      //   }
      // }
      else if (event.ctrlKey && event.shiftKey && event.key === "ArrowRight") {
        event.preventDefault();
        const videoEl = playVideoRef.current;
        if (videoEl && videoEl?.duration) {
          const current = videoEl.currentTime || currentVideoPlayTime;
          const duration = videoEl.duration || videoTiming || 0;
          let nextTime = Math.min(current + arrowIntervalControll*frameTimeLimit, duration);
          videoEl.currentTime = nextTime;
          videoEl.dispatchEvent(new Event("timeupdate"));
          setCurrentVideoPlayTime(nextTime);
          setProgressBarTime(nextTime);
          if (selectedLabelTab?.accindex != -1 && selectedLabelTab?.timingindx != -1) {
            if (selectedLabelTab?.currentGrabbed == 'start') {
              if (nextTime < sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].end) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: nextTime / playVideoRef.current.duration,
                  time: nextTime
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            } else if (selectedLabelTab?.currentGrabbed == 'end') {
              if (nextTime > sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].start) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: nextTime / playVideoRef.current.duration,
                  time: nextTime
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            }
          }
        }
      }
      else if (event.ctrlKey && event.key === "ArrowRight") {
        event.preventDefault();
        const videoEl = playVideoRef.current;
        if (videoEl && videoEl?.duration) {
          const current = videoEl.currentTime;
          const duration = videoEl.duration || videoTiming || 0;
          let nextTime = Math.min(current + 10, duration);
          videoEl.currentTime = nextTime;
          setCurrentVideoPlayTime(nextTime);
          setProgressBarTime(nextTime);
        }
      }
      else if (event.ctrlKey && event.shiftKey && event.key === "ArrowLeft") {
        event.preventDefault();
        const videoEl = playVideoRef.current;
        if (videoEl) {
          const current = videoEl.currentTime || currentVideoPlayTime;
          let prevTime = Math.max(current - arrowIntervalControll*frameTimeLimit, 0);
          videoEl.currentTime = prevTime;
          videoEl.dispatchEvent(new Event("timeupdate"));
          setCurrentVideoPlayTime(prevTime);
          setProgressBarTime(prevTime);
          if (selectedLabelTab?.accindex != -1 && selectedLabelTab?.timingindx != -1) {
            if (selectedLabelTab?.currentGrabbed == 'start') {
              if (prevTime < sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].end) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: prevTime / playVideoRef.current.duration,
                  time: prevTime
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            } else if (selectedLabelTab?.currentGrabbed == 'end') {
              if (prevTime > sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].start) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: prevTime / playVideoRef.current.duration,
                  time: prevTime
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            }
          }
        }
      }
      else if (event.ctrlKey && event.key === "ArrowLeft") {
        event.preventDefault();
        const videoEl = playVideoRef.current;
        if (videoEl) {
          const current = videoEl.currentTime;
          let prevTime = Math.max(current - 10, 0);
          videoEl.currentTime = prevTime;
          setCurrentVideoPlayTime(prevTime);
          setProgressBarTime(prevTime);
        }
      }
      else if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "f") {
        event.preventDefault();
        setmodalType("edit_frame_arrow_controll");
        setOpenlabelSelector((prev) => !prev);        
      }
      else if (event.key === '-' && event?.ctrlKey) {
        event.preventDefault();
        handleKeyZoom(event);
      }
      else if (event.ctrlKey && event.key.toLowerCase() === 'z') {
        if (event.shiftKey) {
          // Ctrl + Shift + Z = Redo
          event.preventDefault();
          redo();
        } else {
          // Ctrl + Z = Undo
          event.preventDefault();
          undo();
        }
      }
    };
    window.addEventListener("keydown", keyEventOperations, false);
    return () => window.removeEventListener("keydown", keyEventOperations, false);
  }, [selectedLabelTab, sublabelTimings]);

  useEffect(() => {
    const video = enableROI ? roiDrawRef.current : playVideoRef.current;
    let retryInterval = null;
    let skipStep = 0.2;
    let maxSkipTime = 30;
    let totalSkipped = 0;
    let lastFailedAt = 0;

    if (!(video) || !video.onloadedmetadata || !video.duration) {
      return; //  Ensure video is ready before proceeding
    }

    // 🟢 Set flag when user plays manually
    const handleUserPlay = () => {
      hasUserInitiatedPlay.current = true;
    };
    video.addEventListener('play', handleUserPlay);

    const handleStallOrError = () => {
      if (!hasUserInitiatedPlay.current) return; //  Prevent auto-retries before user initiates

      if (video && video?.onloadedmetadata && video?.duration) {
        const failedAt = video.currentTime;
        lastFailedAt = failedAt;
        totalSkipped = 0;
        if (video.ended || (!isNaN(video.duration) && video.currentTime >= video.duration)) {
          return;
        }

        const startRetryLoop = async () => {
          while (true) {
            if (!video.paused && !video.ended && !video.seeking) {
              return;
            }

            if (totalSkipped >= maxSkipTime) {
              return;
            }

            const newTime = lastFailedAt + totalSkipped + skipStep;
            totalSkipped += skipStep;

            if (!isNaN(video.duration) && newTime > video.duration) {
              return;
            }

            const currentSrc = video.currentSrc;
            video.src = '';
            video.load();
            video.src = currentSrc;
            video.load();

            video.currentTime = newTime;

            try {
              await video.play();
            } catch (err) {
              console.warn("Still failed, will retry...", err);
            }

            await new Promise(res => setTimeout(res, skipStep * 1000));
          }
        };

        startRetryLoop();
      }
    };

    video.addEventListener('stalled', handleStallOrError);
    video.addEventListener('error', handleStallOrError);

    return () => {
      video.removeEventListener('stalled', handleStallOrError);
      video.removeEventListener('error', handleStallOrError);
      video.removeEventListener('play', handleUserPlay);
      if (retryInterval) clearInterval(retryInterval);
    };
  }, [playing]);

  const updateTime = () => {
    if (timings[0] && timings[0]?.end) {
      let n = timings[0].end;
      let result = [],
        j = (1 / frameTimeLimit) % 1 != 0 ? (frameTimeLimit * frameCount) + frameTimeLimit : 1;
      while (j.toFixed(2) <= n) {
        result.push(parseFloat(j.toFixed(2)));
        j += frameTimeLimit;
      }
      settiming1(result);
      setTimeEnd(n);
    }
  };

  const getWdithToExpand = () => {
    const tenPercentTime = parseFloat((playVideoRef.current.duration * 0.1).toFixed(10));
    const screen75Percentwidth = window.screen.availWidth * 0.8;
    const numberOfwidthToAdd = playVideoRef.current.duration / tenPercentTime;
    const widthToExpand = numberOfwidthToAdd * screen75Percentwidth;
    return widthToExpand;
  }
  const isVideoPlaying = (video) => {
    return !!(
      video &&
      !video.paused &&
      !video.ended &&
      video.readyState >= 3 // HAVE_FUTURE_DATA
    );
  };

  useEffect(() => {
    if (playVideoRef?.current?.onloadedmetadata) {
      if (playing != isVideoPlaying(playVideoRef.current)) {
        setPlaying(isVideoPlaying(playVideoRef.current))
      }
      if (playVideoRef?.current?.onloadedmetadata && playVideoRef?.current.currentTime == videoTiming) {
        playVideoRef.current.currentTime = videoTiming;
        setCurrentVideoPlayTime(videoTiming)
        try {
          if (selectedLabelTab?.accindex != -1 && selectedLabelTab?.timingindx != -1 && playing == true && isLabelVideoPlayerOn == false) {
            if (selectedLabelTab?.currentGrabbed == 'start') {
              if (videoTiming < sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].end) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: videoTiming / playVideoRef.current.duration,
                  time: videoTiming
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            } else if (selectedLabelTab?.currentGrabbed == 'end') {
              if (videoTiming > sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].start) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: videoTiming / playVideoRef.current.duration,
                  time: videoTiming
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            }
          } else {
            handlePauseVideo();
            // progressBarRef.current.style.width = "0%";
            setPlaying(false);
          }
        } catch (error) {
          console.error("Error in handleMouseMoveWhenGrabbed:", error);
        }
      }
      else {
        const seek =
          ((playVideoRef.current.currentTime - timings[0]?.start) /
            playVideoRef.current.duration) *
          100;
        const currentTimeLabels = [], seek1 = parseFloat((playVideoRef.current.currentTime).toFixed(6));
        sublabelTimings.map((sublabel, index) => {
          for (let i = 0; i < sublabel.timings.length; i++) {
            if (parseFloat(sublabel?.timings[i]?.start) <= seek1 && parseFloat(sublabel?.timings[i]?.end) >= seek1) {
              currentTimeLabels.push(sublabel.subname);
              break;
            }
          }
        })
        frameLabels.current = String(currentTimeLabels.join(','));
        setSeekerBar(seek);

        let cpyseekerBar = seekerBar;
        if (+progressBarRef?.current.style.width > 100) {
          cpyseekerBar = 100 - (seekerBar + progressBarRef.current.style.width);
        }
        setCurrentVideoPlayTime(playVideoRef.current.currentTime);
        try {
          if (selectedLabelTab?.accindex != -1 && selectedLabelTab?.timingindx != -1 && playing == true && isLabelVideoPlayerOn == false) {
            if (selectedLabelTab?.currentGrabbed == 'start') {
              if (playVideoRef.current.currentTime < sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].end) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: playVideoRef.current.currentTime / playVideoRef.current.duration,
                  time: playVideoRef.current.currentTime
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            } else if (selectedLabelTab?.currentGrabbed == 'end') {
              if (playVideoRef.current.currentTime > sublabelTimings[selectedLabelTab.accindex].timings[selectedLabelTab.timingindx].start) {
                handleMouseMoveWhenGrabbed({
                  type: 'frame_seek',
                  seekratio: playVideoRef.current.currentTime / playVideoRef.current.duration,
                  time: playVideoRef.current.currentTime
                }, selectedLabelTab.accindex, selectedLabelTab.timingindx, selectedLabelTab.currentGrabbed);
              }
            }
          }
        } catch (error) {
          console.error("Error in handleMouseMoveWhenGrabbed:", error);
        }
        progressBarRef.current.style.width = `${cpyseekerBar}%`;
        progressBarRef1.current.style.width = `${cpyseekerBar}%`;
        if (
          (!isLabelVideoPlayerOn &&
            playVideoRef?.current.currentTime >= timings[0]?.end) ||
          (isLabelVideoPlayerOn &&
            playVideoRef?.current.currentTime >=
            sublabelTimings[currentPlayFrame?.accindex]?.timings[
              currentPlayFrame?.timingindx
            ]?.end)
        ) {
          handlePauseVideo();
          setPlaying(false);
          // progressBarRef.current.style.width = "0%";
          // progressBarRef.current.style.left = `${(timings[0]?.start / playVideoRef.current.duration) * 100
          //   }%`;
          // // progressBarRef1.current.style.width = "0%";
          // progressBarRef1.current.style.left = `${(timings[0]?.start / playVideoRef.current.duration) * 100
          //   }%`;
          // playVideoRef.current.currentTime = timings[0]?.start;
          // roiDrawRef.current.currentTime = timings[0]?.start;
        }
      }
    }
    const time = timings;
    playVideoRef.current.onloadedmetadata = () => {
      if (time.length === 0) {
        time.push({ start: 0, end: playVideoRef.current.duration });
        let labelColors = generateUniqueColors(sublabelTimings.length);
        setgrabberColors(labelColors);
        setLabelContainerHeight(window.screen.availHeight < 850 ? window.screen.availHeight - firstDivRef.current.offsetTop - 124 : window.screen.availHeight - firstDivRef.current.offsetTop - 144)
        setTimings(time);
        updateTime();
        setVideoTiming(playVideoRef.current.duration);
        const widthToExpand = getWdithToExpand()
        setplayBackLength(widthToExpand);
        calculateAnalyticFields();
        addActiveSegments();
        let frameValSum = frameTimeLimit;
        while (frameValSum < 1) {
          timeFrameLimit.push(frameValSum);
          frameValSum = (frameValSum + frameTimeLimit).round(10);
        }
      } else {
        addActiveSegments();
      }
    };
  });

  const labelPlayPauseController = (e, accindx, timeindex, isLabelControll) => {
    let currentPlay = {};
    if (isLabelControll) {
      currentPlay = {
        accindex: accindx,
        timingindx: timeindex,
      };
      setcurrentPlayFrame(currentPlay);
      setisLabelVideoPlayerOn(true);
      if (playVideoRef?.current) {
        playVideoRef.current.currentTime = !(
          currentPlayFrame?.accindex == accindx &&
          currentPlayFrame?.timingindx == timeindex
        )
          ? sublabelTimings[accindx].timings[timeindex].start
          : playVideoRef?.current.currentTime <
            sublabelTimings[accindx]?.timings[timeindex]?.start
            ? sublabelTimings[accindx].timings[timeindex].start
            : playVideoRef?.current.currentTime >
              sublabelTimings[accindx]?.timings[timeindex]?.end
              ? playVideoRef?.current.currentTime <
              sublabelTimings[accindx]?.timings[timeindex]?.start
              : playVideoRef.current.currentTime;
      }
      progressBarRef.current.style.left = `${0}%`;
      progressBarRef1.current.style.left = `${0}%`;
      if (
        !(
          currentPlayFrame?.accindex == accindx &&
          currentPlayFrame?.timingindx == timeindex
        )
      ) {
        setPlaying(false);
      }
    } else {
      setisLabelVideoPlayerOn(false);
      setcurrentPlayFrame({
        accindex: -1,
        timingindx: -1,
      });
    }
    playPause(false, e, accindx, timeindex, isLabelControll);
  };

  //Function handling play and pause logic
  const playPause = (isMainController, e, accindx, timeindex, isLabelControll) => {
    try {
      if (isMainController == true) {
        setisLabelVideoPlayerOn(false);
        setcurrentPlayFrame({
          accindex: -1,
          timingindx: -1,
        });
      }
      if (playing) {
        handlePauseVideo();
      } else {
        if (isMainController == false) {
          if (
            (!isLabelControll &&
              playVideoRef?.current.currentTime >= timings[0]?.end) ||
            (isLabelControll &&
              playVideoRef?.current.currentTime >=
              sublabelTimings[accindx]?.timings[timeindex]?.end)
          ) {
            handlePauseVideo();
            setPlaying(false);
            // progressBarRef.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
            //   }%`;
            progressBarRef.current.style.width = "0%";
            // progressBarRef1.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
            //   }%`;
            progressBarRef1.current.style.width = "0%";
          }
        }
        try {
          handlePlayVideo()
        } catch (e) {
          console.log('Error: ', e);
        }
      }
      setPlaying(!playing);
    } catch {
      console.log("Player play pause issue")
    }
  };

  const updateProgresshoverTime = (event) => {
    let playbackRect = playBackBarRef.current.getBoundingClientRect();
    let seekTime =
      Math.floor(
        (((event.clientX - playbackRect.left) / playbackRect.width) *
          playVideoRef.current.duration) /
        frameTimeLimit
      ) * frameTimeLimit;
    let leftMv = (seekTime / playVideoRef.current.duration) * 100;
    setprogressBarTimStmp(getTimeandFrame(seekTime));
    sethoverTimeLft(leftMv);
  };

  const getSeekTime = (event, playbackRect) => {
    let seekTime = 0;
    if (
      event?.type == "frames" && event?.type == "frame_seek" &&
      event?.accindex != -1 &&
      event?.timingindx != -1
    ) {
      seekTime = event?.time;
    } else if (event?.type == "frames" || event?.type == "frame_seek") {
      seekTime = event?.time;
    } else {
      seekTime =
        Math.floor(
          (((event.clientX - playbackRect.left) / playbackRect.width) *
            playVideoRef.current.duration) /
          frameTimeLimit
        ) * frameTimeLimit;
    }
    if (currentPlayFrame?.accindex >= 0 && currentPlayFrame?.timingindx >= 0) {
      if (seekTime < sublabelTimings[currentPlayFrame?.accindex]?.timings[currentPlayFrame?.timingindx]?.start || seekTime > sublabelTimings[currentPlayFrame?.accindex]?.timings[currentPlayFrame?.timingindx]?.end) {
        setisLabelVideoPlayerOn(false);
        setcurrentPlayFrame({
          accindex: -1,
          timingindx: -1,
        });
      }
    }
    return seekTime;
  }

  //Function handling updating progress logic (clicking on progress bar to jump to different time durations)
  const updateProgress = (
    event,
    isMainTimeFrame = false,
    videoTimeFrameSelect = false
  ) => {
    let playbackRect = {};
    if (videoTimeFrameSelect) {
      playbackRect = playBackBarRef1.current.getBoundingClientRect();
    } else {
      playbackRect = playBackBarRef.current.getBoundingClientRect();
    }
    let seekTime = 0;
    if (
      event?.type == "frames" && event?.type == "frame_seek" &&
      event?.accindex != -1 &&
      event?.timingindx != -1
    ) {
      seekTime = event?.time;
      handleMouseMoveWhenGrabbed(
        {
          ...event,
          seekratio: timings[0].start / playVideoRef.current.duration,
        },
        event.accindex,
        event.timingindx,
        event.currentGrabbed
      );
    } else if (event?.type == "frames" || event?.type == "frame_seek") {
      seekTime = event?.time;
    } else {
      seekTime =
        Math.floor(
          (((event.clientX - playbackRect.left) / playbackRect.width) *
            playVideoRef.current.duration) /
          frameTimeLimit
        ) * frameTimeLimit;
    }
    seekTime = getSeekTime(event, playbackRect);
    setProgressBarTime(seekTime)
    try {
      handlePauseVideo();
      setPlaying(false);
    } catch (e) {
      console.log("Pause failed!!!")
    }
    // find where seekTime is in the segment
    let index = -1;
    let counter = 0;
    for (let times of timings) {
      if (seekTime >= times?.start && seekTime <= times?.end) {
        index = counter;
      }
      counter += 1;
    }
    if (index === -1) {
      return;
    }

    progressBarRef.current.style.width = "0%"; // Since the width is set later, this is necessary to hide weird UI
    progressBarRef.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
      }%`;
    progressBarRef1.current.style.width = "0%"; // Since the width is set later, this is necessary to hide weird UI
    // progressBarRef1.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
    //   }%`;
    playVideoRef.current.currentTime = seekTime;
    roiDrawRef.current.currentTime = seekTime;

    if (isMainTimeFrame) {
      let sblbl = { ...selectedLabelTab },
        midValDiff =
          (selectedLabelTab.frameLabel.end -
            selectedLabelTab.frameLabel.start) /
          2;
      sblbl.frameLabel.start = seekTime - midValDiff;
      sblbl.frameLabel.end = seekTime + midValDiff;
      scrollBarRef.current.scrollLeft =
        ((selectedLabelTab.frameLabel.end - selectedLabelTab.frameLabel.start) *
          frameCount *
          5 -
          10) /
        2;
      if (seekTime - midValDiff <= 0) {
        sblbl.frameLabel.start = 0;
      }
      if (seekTime + midValDiff >= videoTiming) {
        sblbl.frameLabel.end = videoTiming;
      }
      if (seekTime - midValDiff > 0 && seekTime + midValDiff < videoTiming) {
        sblbl.frameLabel.start = seekTime - midValDiff;
        sblbl.frameLabel.end = seekTime + midValDiff;
      }
      setselectedLabelTab(sblbl);
    }
  };
  // ----------------------------------------------------------------------------------------------

  const add_label_to_sublables = (currentTime, labelindx) => {
    let tmpSublabel = [...sublabelTimings];
    let tmpSublabel1 = [...sublabelTimings];
    let crntSltdLabel = { ...selectedLabelTab };

    // const currentTime = findAvailableSpaceForLabel(labelindx);
    // **Step 5: If still no space, throw an overlap error**
    if (!currentTime) {
      setAlertMessage({
        Errortype: "Info",
        title: "No Space Available",
        message: "Cannot add new label",
      });
      openAlertPopup();
      return;
    }

    // **Step 6: Add the new label**
    tmpSublabel1[labelindx].timings.push({ ...currentTime });

    setselectedLabelTab({
      ...selectedLabelTab,
      accindex: labelindx,
      timingindx: tmpSublabel1[labelindx].timings.length - 1,
      currentGrabbed: "end",
      ...tmpSublabel1[labelindx].timings[tmpSublabel1[labelindx].timings.length - 1],
    });
    handleTimingListUpdate(tmpSublabel1);
    updateSublabelTimingsHistory(tmpSublabel1);
    setsubLabelTimings(tmpSublabel1);
  }

  const findAvailableSpaceForLabel = () => {
    let requiredDuration = selectedLabelTab?.timingindx != -1 &&
      selectedLabelTab?.accindex != -1 && selectedLabelTab?.end > 0 ? selectedLabelTab.end - selectedLabelTab.start
      : 20;
    if (!(requiredDuration)) {
      requiredDuration = 20;
    }

    const framePadding = frameTimeLimit * 1;
    const minFrameGap = frameTimeLimit * minFrameSpace;
    const timings = [...timingsList].sort((a, b) => a.start - b.start);

    const isSelected =
      selectedLabelTab &&
      Object.keys(selectedLabelTab).length > 0 &&
      selectedLabelTab.timingindx !== -1 &&
      selectedLabelTab.accindex !== -1;

    // Case 1: No timings exist at all
    if (timings.length === 0) {
      return { start: 0, end: requiredDuration };
    } else if (timings.length > 0 && timings[0]?.start < 20 + frameTimeLimit && timings[0]?.start !== 0 && !isSelected) {
      requiredDuration = timings[0]?.start - frameTimeLimit;
    }
    // If label is selected
    if (isSelected) {
      const selectedIndex = timings.findIndex(
        (item) =>
          item.start === selectedLabelTab.start &&
          item.end === selectedLabelTab.end
      );
      let selectedEnd = selectedLabelTab.end;
      let endSpace = videoTiming - selectedEnd;
      if (selectedIndex == timings.length - 1) {
        if (endSpace >= frameTimeLimit) {
          if (videoTiming < selectedEnd + framePadding + requiredDuration) {
            requiredDuration = videoTiming - (selectedEnd + framePadding);
          }
          return {
            start: selectedEnd + framePadding,
            end: selectedEnd + framePadding + requiredDuration,
          };
        }
      }

      // Try to place immediately after selected
      for (let i = selectedIndex + 1; i < timings.length; i++) {
        const nextStart = timings[i]?.start ?? videoTiming;
        const available = nextStart - selectedEnd;

        // Try same duration first
        if (available >= requiredDuration + framePadding && available > minFrameGap + framePadding) {
          return {
            start: selectedEnd + framePadding,
            end: selectedEnd + framePadding + requiredDuration,
          };
        }

        // Try if enough room for minimum allowed
        if (available > minFrameGap + framePadding) {
          return {
            start: selectedEnd + framePadding,
            end: nextStart - frameTimeLimit,
          };
        }
        selectedEnd = timings[i]?.end
      }
      // If nothing fits between selected and next, place it after last timing if space is available
      endSpace = videoTiming - selectedEnd;
      if (endSpace >= frameTimeLimit) {
        if (videoTiming < selectedEnd + framePadding + requiredDuration) {
          requiredDuration = videoTiming - (selectedEnd + framePadding);
        }
        return {
          start: selectedEnd + framePadding,
          end: selectedEnd + framePadding + requiredDuration,
        };
      }

      return false; // No space found after selected
    }
    // Case 2 and 4: No label selected
    let lastEnd = 0;
    let fallbackSmallest = null;

    if (timings[0]?.start > 0) {
      if (timings[0].start >= requiredDuration) {
        return {
          start: 0,
          end: requiredDuration,
        };
      } else {
        return {
          start: 0,
          end: timings[0].start - frameTimeLimit,
        }
      }
    }
    lastEnd = timings[0]?.end ?? 0;

    for (let i = 1; i <= timings.length; i++) {
      const current = timings[i];
      const currentStart = current?.start ?? videoTiming;

      const available = currentStart - lastEnd;

      if (available >= requiredDuration + framePadding) {
        return {
          start: lastEnd + framePadding,
          end: lastEnd + framePadding + requiredDuration,
        };
      }

      if (available > minFrameGap + framePadding) {
        return {
          start: lastEnd + framePadding,
          end: lastEnd - frameTimeLimit,
        };
      }
      lastEnd = current?.end ?? lastEnd;
    }

    // If nothing fits between selected and next, place it after last timing if space is available
    const endSpace = videoTiming - lastEnd;
    if (endSpace >= frameTimeLimit) {
      if (videoTiming < lastEnd + framePadding + requiredDuration) {
        requiredDuration = videoTiming - (lastEnd + framePadding);
      }
      return {
        start: lastEnd + framePadding,
        end: lastEnd + framePadding + requiredDuration,
      };
    }

    return false; // Totally full
  };


  const addExtramargins = (labelindx) => {
    let tmpSublabel = [...sublabelTimings];
    let tmpSublabel1 = [...sublabelTimings];
    let crntSltdLabel = { ...selectedLabelTab };
    let val = {}, arrval = [], currentTime = {};
    while (true) {
      const availableSpace = findAvailableSpaceForLabel(labelindx);
      if (availableSpace) {
        let breakLoop = true;
        currentTime = {
          start: availableSpace.start,
          end: availableSpace?.end
        }

        if (arrval.includes(JSON.stringify(currentTime))) {
          tmpSublabel1[labelindx].timings = [
            ...tmpSublabel[labelindx].timings,
            {
              ...currentTime
            },
          ];
          add_label_to_sublables(currentTime, labelindx);
          breakLoop = true;
          return;
        }

        arrval.push(JSON.stringify(currentTime));

        for (let ind = 0; ind < tmpSublabel.length; ind++) {
          for (let i = 0; i < tmpSublabel1[ind].timings.length; i++) {
            let rowtime = tmpSublabel1[ind].timings[i];
            val = currentTime;
            if (currentTime?.start <= rowtime?.start && currentTime?.end >= rowtime?.end ||
              currentTime?.start >= rowtime?.start && currentTime?.end <= rowtime?.end ||
              currentTime?.start > rowtime?.start && currentTime?.start < rowtime?.end ||
              currentTime?.end > rowtime?.start && currentTime?.end < rowtime?.end
            ) {
              crntSltdLabel = {
                ...selectedLabelTab,
                accindex: labelindx,
                timingindx: i,
                ...currentTime,
                currentGrabbed: "end"
              }
              breakLoop = false;
              break;
            }
          }
          if (ind == tmpSublabel1.length - 1) {
            breakLoop = true;
            break;
          }
        }
        if (breakLoop) {
          tmpSublabel1[labelindx].timings = [
            ...tmpSublabel[labelindx].timings,
            {
              ...currentTime
            },
          ];
          break;
        }
      } else {
        setAlertMessage({
          Errortype: "Info",
          title: "No Space Available",
          message: "Cannot add new label",
        });
        openAlertPopup();
        return;
      }
    }
    let existingLabels = timingsList, newLabel = currentTime
    for (let label of existingLabels) {
      if (
        (newLabel.start >= label.start && newLabel.start < label.end) || // New label starts inside an existing label
        (newLabel.end > label.start && newLabel.end <= label.end) || // New label ends inside an existing label
        (newLabel.start <= label.start && newLabel.end >= label.end) // New label completely covers an existing label
      ) {
        break;
      }
    }

    if (!(selectedLabelTab?.start >= 0 || selectedLabelTab?.end >= 0)) {
      setselectedLabelTab({
        ...selectedLabelTab,
        ...sublabelTimings[labelindx].timings[selectedLabelTab.timingindx],
      });
    }
    setselectedLabelTab({
      ...selectedLabelTab,
      accindex: labelindx,
      timingindx: tmpSublabel[labelindx].timings.length - 1,
      currentGrabbed: "end",
      ...tmpSublabel[labelindx].timings[(tmpSublabel[labelindx].timings.length - 1)],
    })
    setsubLabelTimings(tmpSublabel);
    handleTimingListUpdate(tmpSublabel);
    updateSublabelTimingsHistory(tmpSublabel);
  };
  // ---------------------------------------------------------------------------------------------
  const deleteEntireLabel = (labelindx) => {
    let tmpSublabel = [...sublabelTimings],
      sblbl = [];
    for (let i = 0; i < tmpSublabel.length; i++) {
      if (i != labelindx) {
        sblbl.push(tmpSublabel[i]);
      }
    }
    setsubLabelTimings(sblbl);
  };
  const calculateMedian = (numbers) => {
    const sorted = Array.from(numbers).sort((a, b) => a - b);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      return (sorted[middle - 1] + sorted[middle]) / 2;
    }

    return sorted[middle];
  }

  const calculateArraySum = (arr) => {
    return arr.reduce((a, b) => a + b, 0)
  }

  const findMinMaxAvgMedian = (arr, timeDiff) => {
    var sum = arr.reduce((a, b) => a + b, 0)
    var sumOfClasses = []; // sum
    Object.keys(timeDiff).map((item, index) => {
      let classTotalFrames = timeDiff[item].reduce((a, b) => a + b, 0)
      sumOfClasses.push(classTotalFrames * frameCount)
    })
    var min = arr[0], minIndx = 0; // min
    var max = arr[0], maxIndx = 0; // max
    for (var i = 1; i < sumOfClasses.length; i++) {
      if (sumOfClasses[i] < min) {
        min = sumOfClasses[i];
        minIndx = i
      }
      if (sumOfClasses[i] > max) {
        max = sumOfClasses[i];
        maxIndx = i;
      }
    }
    let median = calculateMedian(arr);
    let mean = Math.round(sum / arr.length);
    return {
      mean, median, min: `${Object.keys(timeDiff)[minIndx]}(${Math.round(min)})`, max: `${Object.keys(timeDiff)[maxIndx]}(${Math.round(max)})`
    }
  }

  const calculateAnalyticFields = () => {
    let timeDiff = getLabelClassMean();
    let overallDiffFrameList = [];
    if (Object.keys(timeDiff).length != 0) {
      Object.keys(timeDiff).map((item, index) => {
        timeDiff[item].length > 0 && timeDiff[item].map((diff, index) => {
          let diffFrameCount = Math.round(diff * frameCount);
          overallDiffFrameList.push(diffFrameCount)
        })
      })
    }
    let analyticValues = findMinMaxAvgMedian(overallDiffFrameList, timeDiff)
    setAnalyticData({
      ...analyticValues
    })
  }

  const startDrag = (event) => {
    document.addEventListener("mousemove", handleDragging);
    document.addEventListener("mouseup", endDrag);
  };

  const endDrag = () => {
    document.removeEventListener("mousemove", handleDragging);
    document.removeEventListener("mouseup", endDrag);
  };

  const handleDragging = (event) => {
    // Check if Control key is pressed
    if (!event.ctrlKey) return;
    let playbackRect = playBackBarRef.current?.getBoundingClientRect();
    if (!controllerWrapperRef?.current || !playbackRect) return;
    const scrollContainer = controllerWrapperRef.current;
    const scrollRatio = (event.clientX - playbackRect.left) / playbackRect.width;
    const targetScroll = scrollContainer.scrollWidth * scrollRatio - scrollContainer.clientWidth / 2;
    // Smooth and slow scroll
    const dampingFactor = 0.2;
    const scrollX = scrollContainer.scrollLeft + (targetScroll - scrollContainer.scrollLeft) * dampingFactor;
    scrollContainer.scrollLeft = Math.max(0, scrollX);
  };



  const handleMouseMoveWhenGrabbed = (event, accindex = 0, index = 0, type) => {
    try {
      if (event?.type != "frame_seek") {
        playVideoRef.current.currentTime = 0;
        roiDrawRef.current.currentTime = 0;
      }
      let playbackRect = playBackBarRef.current.getBoundingClientRect();
      if (
        (event?.clientX > playbackRect.left &&
          event?.clientX < playbackRect.right) ||
        event?.type == "frames" || event?.type == "frame_seek"
      ) {
        if (event?.type != "frame_seek") {
          handlePauseVideo();
          addActiveSegments();
        }

        let seekRatio = 0;
        let time = [sublabelTimings[accindex].timings[index]];
        let seek = 0;
        if (event?.type == "frames" || event?.type == "frame_seek") {
          seekRatio = event.seekratio;
          seek = event.time;
        } else {
          // const rect = event.currentTarget.getBoundingClientRect();
          // const grabOffset = event.clientX - rect.left;
          // const elementStartX = event.clientX - grabOffset;
          // seekRatio = (elementStartX - playbackRect.left) / playbackRect.width;
          seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;

          seek = parseFloat(
            (
              Math.floor(
                (playVideoRef.current.duration * seekRatio) /
                frameTimeLimit
              ) * frameTimeLimit
            ).toFixed(2)
          );
        }

        let timeframe = [...sublabelTimings];
        let time1 = timeframe[accindex].timings[index];
        let end = time1.end - time1.start;

        let isOverlapping = false;
        let minGap = 0.2; // minimum spacing between segments
        let duration = time1.end - time1.start;
        let indxOfTiming = 0;
        for (let i = 0; i < accindex; i++) {
          indxOfTiming += sublabelTimings[i].timings.length;
        }
        indxOfTiming += index;
        let timings_list = [...timingsList].sort((a, b) => a.start - b.start);
        for (let labelTimeIndex = 0; labelTimeIndex < timings_list.length; labelTimeIndex++) {
          const item = timings_list[labelTimeIndex];
          if (!item || labelTimeIndex === indxOfTiming) continue;
          const itemStart = parseFloat(item.start);
          const itemEnd = parseFloat(item.end);
          const currStart = parseFloat(time1.start);
          const currEnd = parseFloat(time1.end);



          const isOverlap =
            (type === "complete" &&
              ((seek >= itemStart && seek <= itemEnd) ||
                (seek >= itemStart && seek + end <= itemEnd) ||
                (seek <= itemStart && seek + end >= itemEnd) ||
                (seek + end >= itemStart && seek + end <= itemEnd))) ||
            (type === "start" && (seek < itemEnd && currEnd > itemEnd)) ||
            (type === "end" && (seek > itemStart && currEnd < itemStart));

          if (isOverlap) {
            isOverlapping = true;
            // Attempt to auto-adjust based on type
            if (type === "start") {
              const adjustedStart = itemEnd + minGap;
              const adjustedEnd = adjustedStart + duration;
              if (adjustedEnd <= videoTiming) {
                time1.start = adjustedStart;
                time1.end = adjustedEnd;
                seek = adjustedStart;
              }
            } else if (type === "end") {
              const adjustedEnd = itemStart - minGap;
              const adjustedStart = adjustedEnd - duration;
              if (adjustedStart >= 0) {
                time1.start = adjustedStart;
                time1.end = adjustedEnd;
                seek = adjustedEnd;
              }
            } else if (type === "complete") {
              const adjustedStart = itemEnd + minGap;
              const adjustedEnd = adjustedStart + duration;
              if (adjustedEnd <= videoTiming) {
                time1.start = adjustedStart;
                time1.end = adjustedEnd;
                seek = adjustedStart
              }
            }
            // Apply the adjusted safe segment
          }
        }
        if (isOverlapping) {
          sublabelTimings[accindex].timings[index] = { ...time1 };
        }
        if (!isOverlapping) {
          if (type === "start" && seek < time[0]?.end - 0.2) {
            // progressBarRef.current.style.left = `${seekRatio * 100}%`;
            // progressBarRef1.current.style.left = `${seekRatio * 100}%`;
            time[0]["start"] = seek;
            sublabelTimings[accindex].timings[index] = time[0];
            event?.type != "frame_seek" && setPlaying(false);
          } else if (type == "start") {
            setAlertMessage({
              Errortype: "Info",
              title: "Overlap Issue",
              message: "Start should not be greater than End",
            });
            openAlertPopup();
          }
          if (type === "end" && seek > time[0]?.start + 0.2) {
            // progressBarRef.current.style.left = `${(time[0].start / playVideoRef.current.duration) * 100
            //   }%`;
            // progressBarRef1.current.style.left = `${(time[0].start / playVideoRef.current.duration) * 100
            //   }%`;
            time[0]["end"] = seek;
            sublabelTimings[accindex].timings[index] = time[0];
            event?.type != "frame_seek" && setPlaying(false);
          } else if (type == "end") {
            setAlertMessage({
              Errortype: "Info",
              title: "Overlap Issue",
              message: "End should not be less than Start",
            });
            openAlertPopup();
          }

          if (type === "complete") {
            seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
            seek = parseFloat(
              (
                Math.floor(
                  (playVideoRef.current.duration * seekRatio) /
                  frameTimeLimit
                ) * frameTimeLimit
              ).toFixed(2)
            );
            if (seek > 0 && seek + end < videoTiming) {
              time1["start"] = seek;
              time1["end"] = seek + end;
              timeframe[accindex].timings[index] = time1;
              setsubLabelTimings(timeframe);
            }
            event?.type != "frame_seek" && setPlaying(false);
          }
          setsubLabelTimings(sublabelTimings);
          if (
            selectedLabelTab?.accindex == -1 ||
            !(
              selectedLabelTab?.accindex == accindex &&
              index == selectedLabelTab?.timingindx
            )
          ) {
            setframes([]);
            setselectedLabelTab({
              ...sublabelTimings[accindex].timings[index],
              accindex: accindex != undefined ? accindex : 0,
              timingindx: index != undefined ? index : 0,
              currentGrabbed: type,
              frameLabel: selectedLabelTab.frameLabel,
            });
          } else if (event?.type == "frames" || event?.type == "frame_seek") {
            setselectedLabelTab({
              ...sublabelTimings[accindex].timings[index],
              accindex: accindex != undefined ? accindex : 0,
              timingindx: index != undefined ? index : 0,
              currentGrabbed: type,
              frameLabel: selectedLabelTab.frameLabel,
            });
          } else {
            setselectedLabelTab({
              ...sublabelTimings[accindex].timings[index],
              accindex: -1,
              timingindx: -1,
              currentGrabbed: undefined,
              frameLabel: selectedLabelTab.frameLabel,
            });
          }
          progressBarRef.current.style.width = "0%";
          progressBarRef1.current.style.width = "0%";
        } else {
          setAlertMessage({
            Errortype: "Info",
            title: "Overlap Issue",
            message: "Labels Should not overlap",
          });
          openAlertPopup();
        }
      }
    } catch (err) {
      setAlertMessage({
        Errortype: "Error",
        title: "Error",
        message: { err },
      });
      openAlertPopup();
    }
    calculateAnalyticFields();
  };

  const handleMouseMoveWhenframeGrabbed = (event, type) => {
    try {
      let playbackRect = playBackBarRef.current.getBoundingClientRect();
      if (
        event?.clientX > playbackRect.left &&
        event?.clientX < playbackRect.right
      ) {
        let seekRatio = 0;
        let timeframe = { ...selectedLabelTab };
        let time = timeframe.frameLabel;
        let seek = 0;
        seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
        seek = parseFloat(
          (
            Math.floor(
              (playVideoRef.current.duration * seekRatio) /
              frameTimeLimit
            ) * frameTimeLimit
          ).toFixed(2)
        );
        let end = time.end - time.start;
        if (type === "start" && seek < time?.end - 0.2) {
          time["start"] = time.end - seek > 300 ? time.end - 300 : seek;
          if (time?.end - seek > 300) {
            setAlertMessage({
              Errortype: "Error",
              title: "Time Exceeded",
              message: "time difference should not exceed 5 mins",
            });
            openAlertPopup();
          }
          timeframe.frameLabel = time;
        } else if (type === "end" && seek > time?.start + 0.2) {
          time["end"] = seek - time.start > 300 ? time.start + 300 : seek;
          if (seek - time?.start > 300) {
            setAlertMessage({
              Errortype: "Error",
              title: "Time Exceeded",
              message: "time difference should not exceed 5 mins",
            });
            openAlertPopup();
          }
          timeframe.frameLabel = time;
        } else if (type === "complete" && seek > 0 && seek + end < videoTiming) {
          seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
          seek = parseFloat(
            (
              Math.floor(
                (playVideoRef.current.duration * seekRatio) /
                frameTimeLimit
              ) * frameTimeLimit
            ).toFixed(2)
          );
          let end = time.end - time.start;
          time["start"] = seek;
          time["end"] = seek + end;
          timeframe.frameLabel = time;
        } else {
          return;
        }
        setselectedLabelTab(timeframe);
      }
    } catch (err) {
      setAlertMessage({
        Errortype: "Error",
        title: "Error",
        message: { err },
      });
      openAlertPopup();
    }
  };

  const addActiveSegments = () => {
    let colors = "";
    let counter = 0;
    colors += `, rgb(240, 240, 240) 0%, rgb(240, 240, 240) ${(timings[0].start / playVideoRef.current.duration) * 100
      }%`;
    for (let times of timings) {
      if (counter > 0) {
        colors += `, rgb(240, 240, 240) ${(timings[0].end / playVideoRef.current.duration) * 100
          }%, rgb(240, 240, 240) ${(times.start / playVideoRef.current.duration) * 100
          }%`;
      }
      colors += `, #ccc ${(times.start / playVideoRef.current.duration) * 100
        }%, #ccc ${(times.end / playVideoRef.current.duration) * 100}%`;
      counter += 1;
    }
    colors += `, rgb(240, 240, 240) ${(timings[0].end / playVideoRef.current.duration) * 100
      }%, rgb(240, 240, 240) 100%`;
    playBackBarRef.current.style.background = `linear-gradient(to right${colors})`;
  };

  const handlePlayVideo = async () => {
    try {
      await playVideoRef?.current?.play();
      await roiDrawRef?.current?.play();
    } catch (error) {
      if (error?.name === 'AbortError') {
        console.warn('The play request was interrupted by a pause:', error);
      } else {
        console.error('Video play failed:', error);
      }
    }
  };

  const handlePauseVideo = async () => {
    try {
      await playVideoRef?.current?.pause();
      await roiDrawRef?.current?.pause();
    } catch (error) {
      console.error('Video pause failed:', error);
    }
  };

  const onSelectSublabel = (
    accindex,
    indx,
    type = "start",
    isSelectLabelEnabled = false
  ) => {
    if (
      isSelectLabelEnabled == false ||
      selectedLabelTab?.accindex == -1 ||
      !(
        selectedLabelTab?.accindex == accindex &&
        indx == selectedLabelTab?.timingindx
      )
    ) {
      setframes([]);
      setselectedLabelTab({
        ...sublabelTimings[accindex].timings[indx],
        accindex: accindex != undefined ? accindex : 0,
        timingindx: indx != undefined ? indx : 0,
        currentGrabbed: type,
        frameLabel: selectedLabelTab.frameLabel,
      });
    } else {
      setselectedLabelTab({
        ...sublabelTimings[accindex].timings[indx],
        accindex: -1,
        timingindx: -1,
        currentGrabbed: undefined,
        frameLabel: selectedLabelTab.frameLabel,
      });
    }
  };

  const getTimeandFrame = (time) => {
    if (time) {
      let seconds = parseFloat(time.toFixed(10));
      let mins = [scameTimeMeasure].reduceRight(
        (p, b) => (r) => [Math.floor(r / b)].concat(p(r % b)),
        (r) => [r]
      )(seconds);
      let secs = mins[1]
        ? [1].reduceRight(
          (p, b) => (r) => [Math.floor(r / b)].concat(p(r % b)),
          (r) => [r]
        )(mins[1])
        : [0, 0];
      let frametimeinful = frameTimeLimit * 100;
      let frame = 0;
      if ((1 / frameTimeLimit) % 1 != 0) {
        frametimeinful = frameTimeLimit.round(5) * 100;
        let secsMultipliedVal = (secs[1].round(5) * 100) >= 1 ? (secs[1].round(5) * 100) : 0;
        frame = Math.floor(secsMultipliedVal / frametimeinful);
        frame = frame % frameCount;
      } else {
        frame = Math.floor((secs[1].round(digitslngth) * 100) / frametimeinful);
      }
      return `${mins[0] < 10 ? '0' + (mins[0] < 0 ? 0 : mins[0]) : mins[0]}:${secs[0] < 10 ? '0' + (secs[0] < 0 ? 0 : secs[0]) : secs[0]}.${(frame + 1) < 10 ? '0' + ((frame + 1) < 0 ? 0 : (frame + 1)) : frame + 1}`;
    }
    return "0.0:0";
  };
  const closeCurrentEditable = () => {
    setEditableInp({
      accindex: -1,
      timingindx: -1,
      currentGrabbed: '',
      currentValue: ''
    })
  }

  const gettimeEntered = (timeVal) => {
    let timeFrames = timeVal.split(/[\:\.]+/);
    let givenTimeFrame = 0, timeMultiply = [60, 1, frameTimeLimit], limit = [-1, 60, frameCount], validInp = true;
    let framedigit = digitslngth;
    for (let i = 0; i < timeFrames.length; i++) {
      let inputValue = parseInt(timeFrames[i])

      if (limit[i] == -1 || inputValue <= limit[i]) {
        if (i == 2) {
          if ((1 / frameTimeLimit) % 1 != 0) {
            framedigit = 5
          }
          givenTimeFrame = givenTimeFrame + (timeFrames[i] * timeMultiply[i].round(framedigit))
        } else {
          givenTimeFrame = givenTimeFrame + (timeFrames[i] * timeMultiply[i])
        }
      } else {
        validInp = false;
        break;
      }
    }
    if (givenTimeFrame > videoTiming || !validInp) {
      return -1;
    }
    givenTimeFrame = givenTimeFrame - frameTimeLimit.round(framedigit);
    return givenTimeFrame;
  }

  const handleKeyDown = (e) => {
    let regexp = /[0-9]+[\:]*[0-9]*[\.]*[0-9]*/
    if (e.key === 'Enter' && editableInp?.accindex != -1 && editableInp?.timingindx != -1 && editableInp?.currentGrabbed != '') {
      if (regexp.test(editableInp?.currentValue)) {
        let timeval = gettimeEntered(editableInp.currentValue);
        if (timeval != -1) {
          handleMouseMoveWhenGrabbed({
            type: 'frames',
            seekratio: timings[0].start / playVideoRef.current.duration,
            time: timeval
          }, editableInp.accindex, editableInp.timingindx, editableInp.currentGrabbed);
          // sublabelTimingscpy[editableInp.accindex].timings[editableInp.timingindx][editableInp.currentGrabbed]=gettimeEntered(editableInp.currentValue);
          closeCurrentEditable();
        } else {
          setAlertMessage({
            Errortype: "Error",
            title: "Invalid Input",
            message: "Valid Time must be provided",
          });
          openAlertPopup();
        }
      } else {
        setAlertMessage({
          Errortype: "Error",
          title: "Invalid Input",
          message: "Valid Time must be provided",
        });
        openAlertPopup();
      }
    }
  }

  const editableOnchangeHandler = (e) => {
    const regEx = /\d*/;
    let inpVal = e.target.value.replace(/[^0-9]+/g, "");
    if (inpVal.length < 7 && regEx.test(inpVal)) {
      let arrvl = inpVal.split(""), finalStr = '';
      for (let i = 0; i < arrvl.length; i++) {
        finalStr = finalStr + (i == 2 ? ':' + arrvl[i] : i == 4 ? '.' + arrvl[i] : arrvl[i]);
      }
      setEditableInp({
        ...editableInp,
        currentValue: finalStr
      })
    }
  }

  // onchange handlers for the label selectors

  const handleToggleSelectAll = () => {
    setSelectAll((prev) => {
      if (!prev) setfilteredSublabelTimings([...sublabelTimings]);
      else setfilteredSublabelTimings([]);
      return !prev;
    });
  };

  const roiOnChangeHandler = (e) => {
    if (e.target.value != 0) {
      setShowCroppedVideo(false)
      setEnableROI(false)
    } else {
      setSelectedEditableROIindex(-1);
    }
    setSelecteROIindex(e.target.value);
    setZoomAreaRatio({ ...roiList[e.target.value] })
  }
  const saveTheAnnotationData = (roiList) => {
    handleSubmit(sublabelTimings, roiList)
  }
  const saveAnnotationBackup = (roiList) => {
    handleSubmitBackup(sublabelTimings, roiList)
  }

  const handleMetaFileDownload = () => {
    download_meta_file(urlParams.backendId, urlParams.collectionPath);
  }

  const handleDownloadVideoFrames = () => {
    try {
      setEportFrameLoader(true)
      let measurementValues = { x: 0, y: 0, width: 0, height: 0 }
      if (selecteROIindex > 0) {
        measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, roiList[selecteROIindex].x, roiList[selecteROIindex].y, roiList[selecteROIindex].width, roiList[selecteROIindex].height);
      }
      download_video_frames(urlParams.backendId, urlParams.collectionPath, roiList[selecteROIindex]?.roi_id ? roiList[selecteROIindex].roi_id : -1
        , measurementValues.x
        , measurementValues.y
        , measurementValues.width
        , measurementValues.height,
        frameInterval,
        setFrameExport_progressPercent,   // 👈 pass setter
        setFrameExport_statusMessage      // 👈 pass setter
      ).then(() => {
        setAlertMessage({
          Errortype: "Success",
          title: "Success",
          message: 'Export completed',
        });
        openAlertPopup();
        setEportFrameLoader(false)
        handleCloseLabelSelector();
      }).catch((e) => {
        setAlertMessage({
          Errortype: "Error",
          title: "Error",
          message: e.message || String(e),
        });
        openAlertPopup();
        setEportFrameLoader(false)
        handleCloseLabelSelector();
      })
    } catch (e) {
      setAlertMessage({
        Errortype: "Error",
        title: "Error",
        message: e.message || String(e),
      });
      openAlertPopup();
      setEportFrameLoader(false)
      handleCloseLabelSelector();
    }
  }

  const handleSubmitMeasurements = (measures) => {
    let pxToPercentage = calculateBoxPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, measures.x, measures.y, measures.width, measures.height);
    let percentageToPixel = calculateBoxFromPercentage(visibleVideoDimensions.width, visibleVideoDimensions.height, pxToPercentage.x, pxToPercentage.y, pxToPercentage.width, pxToPercentage.height);
    setZoomArea(percentageToPixel);
  }
  const getLabelClassMean = () => {
    let timeDiffList = {};
    sublabelTimings.map((sibling, accindex) => {
      sibling.timings.map((timing, index) => {
        if (timeDiffList[sibling.subname] == undefined) {
          let diff = timing.end - timing.start;
          timeDiffList[`${sibling.subname}`] = [diff]
        } else {
          timeDiffList[sibling.subname].push(timing.end - timing.start)
        }
      })
    })
    return timeDiffList;
  }

  const handleCopyDurationToClipBoard = () => {
    const duration = sublabelTimings[contextMenu.accindex].timings[contextMenu.index].end - sublabelTimings[contextMenu.accindex].timings[contextMenu.index].start;
    setCopiedDuration(duration)
  }
  const handleEditDuration = () => {

  }
  const handleOverWriteDuration = () => {
    const sbLblTimings = Object.assign({}, sublabelTimings)
    sbLblTimings[contextMenu.accindex].timings[contextMenu.index].end = sbLblTimings[contextMenu.accindex].timings[contextMenu.index].start + copiedDuration;
    setsubLabelTimings(sbLblTimings);
    setContextMenu(null);
  }

  const handleRightClickEvent = (type) => {
    if (type === 'copy') {
      handleCopyDurationToClipBoard();
    } else if (type === 'edit') {
      handleEditDuration();
    } else if (type === 'overwrite') {
      handleOverWriteDuration();
    }
    setContextMenu(null);
  }

  const handleOpen = (event) => {
    if (event === 'Add') {
      setRoiLabelModal(false);
      setRoiLabelModal(true);
      setNewROILabel('');
    } else {
      setRoiLabelModal(false);
      const eventMsg = event == 'Add ROI' ? `Are you sure to add '${newROILabel}' ROI to collection '${collectionLabelset.length > 0 ? collectionLabelset[0]?.labelSetName ? collectionLabelset[0]?.labelSetName : urlParams.collectionID : urlParams.collectionID}'` :
        event == 'Update' ? "Are you sure to update this ROI '" + roiList[selectedEditableROIindex].label + "'?" :
          event == 'Delete' ? selectedEditableROIindex == -1 ? "Do you want to delete selected ROI?" : ("Are you sure to delete '" + roiList[selectedEditableROIindex].label + "' from Collection '" + (collectionLabelset[0]?.labelSetName ? collectionLabelset[0]?.labelSetName : urlParams.collectionID) + "'?") : '';
      setbuttonAction({
        event: event,
        eventMessage: eventMsg
      })
      setOpen(true);
    }
  };
  const handleCloseRoiLabelModal = () => {
    setRoiLabelModal(false);
    setNewROILabel('');
  }
  const handleEnableEdit = (labelName) => {
    setLabelsetsAccessKeys({
      ...labelsetsAccessKeys,
      [labelName]: {
        ...labelsetsAccessKeys[labelName],
        enableEdit: true
      }
    })
  }
  const handleDisableEdit = (labelName) => {
    setLabelsetsAccessKeys({
      ...labelsetsAccessKeys,
      [labelName]: {
        ...labelsetsAccessKeys[labelName],
        enableEdit: false
      }
    })
  }
  const handleKeyChange = (e, labelName) => {
    if (e.target.value.length > 1) {
      setAlertMessage({
        Errortype: "Error",
        title: "Invalid Key",
        message: "Key should be a single character",
      });
      openAlertPopup();
      return;
    }
    setLabelsetsAccessKeys({
      ...labelsetsAccessKeys,
      [labelName]: {
        ...labelsetsAccessKeys[labelName],
        labelAccessKey: /^[A-Z]$/.test(e.target.value)
          ? e.target.value.toLowerCase() // convert uppercase letters to lowercase
          : e.target.value // leave numbers and lowercase letters as is
      }
    });
  }
  const handleSaveAccessKey = (sublabel, label) => {
    let isValid = true;
    if (labelsetsAccessKeys[sublabel.labelName]?.labelAccessKey.length == 0) {
      setAlertMessage({
        Errortype: "Error",
        title: "Invalid Key",
        message: "Key should not be empty",
      });
      openAlertPopup();
      return;
    }
    if (!availableKeys.includes(labelsetsAccessKeys[sublabel.labelName].labelAccessKey.toLowerCase())) {
      setAlertMessage({
        Errortype: "Error",
        title: "Invalid Key",
        message: `Key for ${sublabel.labelName} should be valid!!!`,
      });
      openAlertPopup();
      return;
    }
    label.labels.forEach((label) => {
      if (label.labelName != sublabel.labelName && labelsetsAccessKeys[sublabel.labelName].labelAccessKey.toLowerCase() == labelsetsAccessKeys[label.labelName].labelAccessKey.toLowerCase()) {
        setAlertMessage({
          Errortype: "Error",
          title: "Invalid Key",
          message: `Key for ${sublabel.labelName} is already used!!!`,
        });
        openAlertPopup();
        isValid = false;
        return;
      }
    })
    if (isValid) {
      updateAccessKey(sublabel?.id, {
        ...sublabel,
        "labelAccessKey": labelsetsAccessKeys[sublabel.labelName]?.labelAccessKey
      }).then(() => {
        setAlertMessage({
          Errortype: "Success",
          title: "Success",
          message: `Access key for ${sublabel.labelName} updated successfully`,
        });
        openAlertPopup();
        handleDisableEdit(sublabel.labelName);
        handleGetCollectionLabelsetDetails(urlParams.collectionID, currentlabel)
      }).catch((e) => {
        setAlertMessage({
          Errortype: "Error",
          title: "Error",
          message: e.message || String(e),
        });
        openAlertPopup();
      });
    }
  }

  const handleSubmitAllKeys = () => {
    let isValid = true;
    collectionLabelset.map((labelset, index) => {
      if (labelset?.labelSetName == currentlabel) {
        labelset.labels.forEach((label) => {
          if (labelsetsAccessKeys[label.labelName].labelAccessKey.length == 0) {
            setAlertMessage({
              Errortype: "Error",
              title: "Invalid Key",
              message: `Key for ${label.labelName} should not be empty`,
            });
            openAlertPopup();
            isValid = false;
            return;
          }
          if (!availableKeys.includes(labelsetsAccessKeys[label.labelName].labelAccessKey.toLowerCase())) {
            setAlertMessage({
              Errortype: "Error",
              title: "Invalid Key",
              message: `Key for ${label.labelName} should be alphanumeric`,
            });
            openAlertPopup();
            isValid = false;
            return;
          }
        })
      }
    })
    collectionLabelset.map((labelset, index) => {
      if (labelset?.labelSetName == currentlabel) {
        for (let i = 0; i < labelset.labels.length; i++) {
          labelset.labels.forEach((label) => {
            if (label.labelName != labelset.labels[i].labelName && labelsetsAccessKeys[labelset.labels[i].labelName].labelAccessKey.toLowerCase() == labelsetsAccessKeys[label.labelName].labelAccessKey.toLowerCase()) {
              setAlertMessage({
                Errortype: "Error",
                title: "Invalid Key",
                message: `Key for ${labelset.labels[i].labelName} is already used!!!`,
              });
              openAlertPopup();
              isValid = false;
              return;
            }
          })
        }
      }
    })
    const reqPayload = [];
    let labelSetId = -1;
    collectionLabelset.map((labelset, index) => {
      if (labelset?.labelSetName == currentlabel) {
        labelSetId = labelset.labelSetId;
        labelset.labels.forEach((label) => {
          reqPayload.push({
            ...label,
            "labelAccessKey": labelsetsAccessKeys[label.labelName]?.labelAccessKey
          })
        })
      }
    })
    if (isValid) {
      updateAllAccessKeys(labelSetId, reqPayload).then(() => {
        setAlertMessage({
          Errortype: "Success",
          title: "Success",
          message: "Access keys updated successfully",
        });
        openAlertPopup();
        handleDisableEditLabels();
        handleGetCollectionLabelsetDetails(urlParams.collectionID, currentlabel)
      }).catch((e) => {
        setAlertMessage({
          Errortype: "Error",
          title: "Error",
          message: e.message || String(e),
        });
        openAlertPopup();
      });
    }
  }

  const handleEnableEditLabels = () => {
    setEnableLabelEdit(!enableLabelEdit);
    if (enableLabelEdit) {
      handleDisableEditLabels();
    }
  }
  const handleDisableEditLabels = () => {
    setEnableLabelEdit(false);
    const tmpAccessKeys = { ...labelsetsAccessKeys };
    collectionLabelset.map((label, index) => {
      if (label?.labelSetName == currentlabel) {
        label.labels.forEach((label) => {
          tmpAccessKeys[label.labelName].enableEdit = false;
        })
      }
    })
    setLabelsetsAccessKeys(tmpAccessKeys);
  }

  const leftMove = playVideoRef?.current?.currentTime ? (playVideoRef.current.currentTime / playVideoRef.current.duration) * 100 : 0;

  return (
    <div onClick={closeCurrentEditable}>
      <Modal
        open={roiLabelModal}
        onClose={handleCloseRoiLabelModal}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box style={{ ...style }}
        >
          <div className="d-flex justify-content-between">
            <h4>Please enter ROI label name</h4>
            <FontAwesomeIcon icon={faTimes} className='close-icon cursor-pointer' style={{ marginTop: '-15px', marginRight: '-10px' }} onClick={handleCloseRoiLabelModal} />
          </div>
          <div className='align-items-center'>
            <input className='form-control' type="text" value={newROILabel} onChange={(e) => setNewROILabel(e.target.value)} placeholder={`Please enter ROI label name`} />
            <button className='btn btn-primary' style={{ width: '100%', marginTop: '1rem' }} onClick={() => { handleOpen('Add ROI') }}>Save ROI</button>
          </div>
        </Box>
      </Modal>
      <div className='sidebar-container'>
        <Tooltip title='Shortcuts' placement='right' arrow>
          <button
            className='sidebar-icon'
            onClick={() => {
              setmodalType("shortcuts");
              handleOpenLabelSelector();
            }}
          >
            <FaKeyboard className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>

        <Tooltip title='Export Video Frames' placement='right' arrow>
          <button
            className='sidebar-icon'
            disabled={enableROI}
            style={{ visibility: !enableROI ? "visible" : "hidden" }}
            onClick={() => {
              handleOpenLabelSelector();
              setmodalType("export_frames");
            }}
          >
            <TiExport className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>

        <Tooltip
          title={selecteROIindex !== 0 ? "Edit ROI" : "Add New ROI"}
          placement='right'
          arrow
        >
          <button
            className='sidebar-icon'
            onClick={() => {
              if (selecteROIindex !== 0 && !enableROI) {
                setSelectedEditableROIindex(selecteROIindex);
                let newheight =
                  window.screen.availHeight < 900
                    ? window.screen.availHeight - 128
                    : window.screen.availHeight - 190;
                let widthVal =
                  (visibleVideoDimensions.videoWidth /
                    visibleVideoDimensions.videoheight) *
                  newheight;
                let measurementValues = calculateBoxFromPercentage(
                  widthVal,
                  newheight,
                  roiList[selecteROIindex].x,
                  roiList[selecteROIindex].y,
                  roiList[selecteROIindex].width,
                  roiList[selecteROIindex].height
                );
                measurementValues = { ...measurementValues, editable: false };
                setZoomArea(measurementValues);
                setSelecteROIindex(0);
              } else {
                setZoomArea(null);
                setSelectedEditableROIindex(-1);
              }
              setShowCroppedVideo(false);
              setEnableROI(!enableROI);
            }}
          >
            {enableROI ? <IoCloseSharp className='sidebar-icon-svg' size="24px" /> : <FaCropAlt className='sidebar-icon-svg' size="24px" />}
          </button>
        </Tooltip>
        <Tooltip title='Saved ROI' placement='right' arrow>
          <button
            className='sidebar-icon'
            style={{ visibility: !enableROI ? "visible" : "hidden" }}
            onClick={() => {
              setmodalType("select_roi");
              handleOpenLabelSelector();
            }}
          >
            <HiClipboardDocumentList className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>

        <Tooltip title='ROI Info' placement='right' arrow>
          <button
            className='sidebar-icon'
            onClick={() => {
              setmodalType("roi");
              handleOpenLabelSelector();
            }}
          >
            <IoInformationCircleSharp className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>
        <Tooltip title='Annotation Analytics' placement='right' arrow>
          <button
            className='sidebar-icon'
            onClick={handleOpenChartData}
          >
            <FaChartBar className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>
        <Tooltip title='Download Meta File' placement='right' arrow>
          <button
            className='sidebar-icon'
            onClick={handleMetaFileDownload}
          >
            <FaDownload className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>

        <Tooltip title='Save Annotations' placement='right' arrow>
          <button
            className='sidebar-icon'
            style={{ visibility: !enableROI ? "visible" : "hidden" }}
            onClick={saveTheAnnotationData}
          >
            <IoIosSave className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>
        <Tooltip title='Complete & Backup Annotations' placement='right' arrow>
          <button
            className='sidebar-icon'
            style={{ visibility: !enableROI ? "visible" : "hidden" }}
            onClick={saveAnnotationBackup}
          >
            <MdBackup className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>

        {/* <Tooltip title='Backup Lists' placement='right' arrow>
          <button
            className='sidebar-icon'
            style={{ visibility: !enableROI ? "visible" : "hidden" }}
             onClick={() => {
              setmodalType("labelSelector");
              handleOpenLabelSelector();
            }}
          >
            <MdOutlineSettingsBackupRestore   className='sidebar-icon-svg' size="24px"  />
          </button>
        </Tooltip> */}

        <Tooltip title='Select Label' placement='right' arrow>
          <button
            className='sidebar-icon'
            style={{ visibility: !enableROI ? "visible" : "hidden" }}
            onClick={() => {
              setmodalType("select_labels");
              handleOpenLabelSelector();
            }}
          >
            <FaThList className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>

        <Tooltip title='Visible Labels' placement='right' arrow>
          <button
            className='sidebar-icon'
            onClick={() => {
              setmodalType("labelSelector");
              handleOpenLabelSelector();
            }}
          >
            <MdFilterListAlt className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>
        <Tooltip title='Labels Info' placement='right' arrow>
          <button
            className='sidebar-icon'
            onClick={() => {
              setmodalType("labelsInfo");
              handleOpenLabelSelector();
            }}
          >
            <IoIosInformationCircle className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>
        <Tooltip title='Add New Label' placement='right' arrow>
          <button
            className="sidebar-icon"
            style={{ marginTop: `${firstDivRef && firstDivRef?.current ? firstDivRef.current.offsetTop - 530 : '0'}px` }}
            onClick={() => {
              setmodalType("add_new_label");
              handleOpenLabelSelector();
            }}
          >
            <BsFillPlusCircleFill className='sidebar-icon-svg' size="24px" />
          </button>
        </Tooltip>
      </div>

      <div className='wrapper'>
        <div className='videoAndLabelWrapper'>
          <div
            style={{
              marginLeft: window.screen.availWidth > 1400 ? "-7.9%" : "0.5%",
              position: "absolute",
              width: '8vw'
            }}
          >
            <div className="video-info-div" title={`${selecteROIindex == 0 ? "Full Video" : (roiList[selecteROIindex]?.label != '' ? roiList[selecteROIindex].label : 'ROI ' + roiList[selecteROIindex].roi_id)}`}>ROI: <span style={{ color: "green" }}>{selecteROIindex == 0 ? "Full Video" : (roiList[selecteROIindex]?.label != '' ? roiList[selecteROIindex].label : 'ROI ' + roiList[selecteROIindex].roi_id)}</span></div>
            <div className="video-info-div" title={`${currentlabel}`}>Labelset: <span style={{ color: "green" }}>{currentlabel}</span></div>
            <div className="video-info-div" title={`${frameLabels.current}`}>Label: <span style={{ color: "green" }}>{frameLabels.current}</span></div>
            <div className="video-info-div" title={`${frameLabels.current}`}>Video Dimension: <span style={{ color: "green" }}>{visibleVideoDimensions.videoWidth},{visibleVideoDimensions.videoheight}</span></div>
          </div>

          <div className='videoContainer'>
            <ROISelector
              isMuted={isMuted}
              setSeekerBar={setSeekerBar}
              vidsrc={videoUrl}
              progressBarTime={progressBarTime}
              zoomAreaRatio={zoomAreaRatio}
              setZoomAreaRatio={setZoomAreaRatio}
              zoomArea={zoomArea}
              setZoomArea={setZoomArea}
              visibleVideoDimensions={visibleVideoDimensions}
              setVisibleVideoDimensions={setVisibleVideoDimensions}
              showCroppedVideo={showCroppedVideo}
              setShowCroppedVideo={setShowCroppedVideo}
              enableROI={enableROI}
              playPause={playPause}
              selecteROIindex={selecteROIindex}
              setSelecteROIindex={setSelecteROIindex}
              roiList={roiList}
              addRoiCoordinates={addRoiCoordinates}
              updateRoiCoordinates={updateRoiCoordinates}
              deleteRoiCoordinates={deleteRoiCoordinates}
              setroiList={setroiList}
              openAlertPopup={openAlertPopup}
              setAlertMessage={setAlertMessage}
              saveTheAnnotationData={saveTheAnnotationData}
              setMeasurements={setMeasurements}
              selectedEditableROIindex={selectedEditableROIindex}
              setSelectedEditableROIindex={setSelectedEditableROIindex}
              urlParams={urlParams}
              ref={{ progressBarRef, playVideoRef, roiDrawRef }}
              setEnableROI={setEnableROI}
              open={open}
              setOpen={setOpen}
              buttonAction={buttonAction}
              setbuttonAction={setbuttonAction}
              newROILabel={newROILabel}
              handleOpen={handleOpen}
              playing={playing}
              setPlaying={setPlaying}
            />
            <div className='playback playbackVideo'>
              <div
                className='seekable'
                ref={playBackBarRef1}
                onClick={(e) => updateProgress(e, true, true)}
              ></div>
              <div className='progress_bar_for_video'></div>
              <div className='progress' ref={progressBarRef1}></div>
            </div>
            <div className='controls'>
              <div className='player-controls'>
                <div className='roi-info-container'>
                  {enableROI && (
                    <>
                      <button
                        disabled={!zoomArea}
                        className='roi-selector-delete-button'
                        title='Delete ROI'
                        style={{
                          cursor: !zoomArea ? "not-allowed" : "pointer",
                          opacity: !zoomArea ? "0.5" : "1",
                        }}
                        onClick={() => handleOpen("Delete")}
                      >
                        <Tooltip
                          title={"Delete ROI."}
                          disableHoverListener={zoomArea}
                          placement='top'
                          arrow
                        >
                          <FontAwesomeIcon icon={faTrash} /> Delete
                        </Tooltip>
                      </button>
                      <button
                        disabled={!zoomArea}
                        className='roi-info-button'
                        title='ROI Info'
                        style={{
                          cursor: !zoomArea ? "not-allowed" : "pointer",
                          opacity: !zoomArea ? "0.5" : "1",
                        }}
                        onClick={() => {
                          setmodalType("roi");
                          handleOpenLabelSelector();
                        }}
                      >
                        <Tooltip
                          title={"ROI Info."}
                          disableHoverListener={zoomArea}
                          placement='top'
                          arrow
                        >
                          <IoInformationCircleSharp />
                        </Tooltip>
                      </button>
                    </>
                  )}
                </div>
                <div>
                  {enableROI && (
                    <button
                      className='roi-selector-cancel-button'
                      title='Cancel ROI'
                      style={{
                        width: enableROI ? "9vw" : "auto",
                        marginLeft: enableROI ? "-19vh" : "0px",
                      }}
                      onClick={() => {
                        setZoomArea(null);
                        setSelectedEditableROIindex(-1);
                        setShowCroppedVideo(false);
                        setEnableROI(!enableROI);
                      }}
                    >
                      {enableROI ? (
                        <IoCloseSharp style={{ marginTop: "-3px" }} />
                      ) : (
                        <FaCropAlt />
                      )}{" "}
                      Cancel
                    </button>
                  )}
                  <button
                    className='play-control videoPlayPuase'
                    title='Play/Pause'
                    style={{
                      width: enableROI ? "4vw" : "auto",
                      marginLeft: enableROI ? "1vh" : "0px",
                    }}
                    onClick={() => playPause(true)}
                  >
                    {playing ? (
                      <FontAwesomeIcon icon={faPause} />
                    ) : (
                      <FontAwesomeIcon icon={faPlay} />
                    )}
                  </button>
                </div>
              </div>
              <div className='player-controls'>
                <div className='remaining-time-container'>
                  <label>Remaining Time</label>
                  <p className='remaining-time'>
                    {getTimeandFrame(videoTiming - maxAnnotated)}
                  </p>
                </div>
                <select
                  id='speedControl'
                  className='video-speed-controller'
                  value={playbackRate}
                  onChange={handleSpeedChange}
                >
                  {[0.25, 0.5, 0.75, 1, 2, 3].map((speed) => (
                    <option key={speed} value={speed}>
                      {speed}X
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className='label_contrll_wrapper'>
          <div className='controller_wrapper' ref={controllerWrapperRef}>
            <div className='onscrollControllContainer'>
              <div
                className='playback playbackControllContainer'
                style={{ width: playbackLength, marginBottom: "0px" }}
              >
                <div
                  className='seekable'
                  ref={playBackBarRef}
                  onClick={(e) => updateProgress(e, true)}
                  onMouseEnter={updateProgresshoverTime}
                ></div>
                <div className='progress' ref={progressBarRef}></div>
                <p
                  style={{ marginLeft: `${leftMove}` + "%" }}
                  className='progress progress_time1 '
                >
                  <p className='timeFrameline'>|</p>
                  <p
                    className='timeFrame'
                    style={{
                      cursor: "pointer",
                      zIndex: "100",
                      height: "14px",
                      // marginLeft: `${(leftMove/100)*window.screen.availWidth>window.screen.availWidth*0.50 ? -65 : 0}px`
                    }}
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `${getTimeandFrame(currentVideoPlayTime)}`
                      );
                      setAlertMessage({
                        Errortype: "Info",
                        title: "Copied!!!",
                        message: "Measurements are copied",
                      });
                      openAlertPopup();
                    }}
                  >
                    {currentVideoPlayTime
                      ? getTimeandFrame(currentVideoPlayTime)
                      : "0.0:0"}
                  </p>
                </p>
                {progressBarTimStmp != -1 && (
                  <p
                    style={{
                      marginLeft: hoverTimeLft + "%",
                      marginTop:
                        Math.abs(leftMove - hoverTimeLft) < 4.5
                          ? "14px"
                          : "-14px",
                    }}
                    className='progress progress_time'
                  >
                    <p
                      className='timeFrameline'
                      style={{
                        visibility:
                          Math.abs(leftMove - hoverTimeLft) < 4.5
                            ? "hidden"
                            : "visible",
                      }}
                    >
                      |
                    </p>
                    <p className='timeFrame'>{progressBarTimStmp}</p>
                  </p>
                )}
              </div>
              <div
                className='playback_timer'
                style={{ width: playbackLength, marginTop: "0.5rem" }}
                onClick={(e) => updateProgress(e, true)}
                onMouseMove={updateProgresshoverTime}
                onMouseLeave={() => setprogressBarTimStmp(-1)}
              >
                {/* time selector time line  */}
                <div className='timingcontainer'>
                  <FrameTime
                    timing1={timing1}
                    n={timeEnd}
                    playbackLength={playbackLength}
                    hms={getTimeandFrame}
                    isTopController={true}
                    frameCount={frameCount}
                    frameTimeLimit={frameTimeLimit ? frameTimeLimit : 0}
                  />
                </div>
              </div>
            </div>
            {/* frame seek time limit controller */}
            {/* <div
            className='playback'
            style={{ marginBottom: "6rem", width: playbackLength }}
          >
            <div>
              <div key={"grabber_frames"}>
                <div
                  draggable
                  id='grabberStart'
                  className='grabber frammerstart'
                  style={{
                    left: `${(parseInt(selectedLabelTab.frameLabel.start) /
                      videoTiming) *
                      100
                      }%`,
                    background: frameViewColor,
                  }}
                  onDragStart={(event) => {
                    handleMouseMoveWhenGrabbed(event, "start");
                  }}
                  onDragEnd={(event) => {
                    handleMouseMoveWhenGrabbed(event, "start");
                  }}
                >
                  {"["}
                </div>
                <p
                  draggable
                  className='markerContainer completegrabber'
                  style={{
                    background: frameViewColor,
                    left: `${(parseInt(selectedLabelTab.frameLabel.start) /
                      videoTiming) *
                      100
                      }%`,
                    width: `${(selectedLabelTab?.frameLabel?.end / videoTiming) * 100 -
                      (parseInt(selectedLabelTab.frameLabel.start) /
                        videoTiming) *
                      100
                      }%`,
                  }}
                  onDragEnd={(event) => {
                    handleMouseMoveWhenGrabbed(event, "complete");
                  }}
                >
                  {" "}
                </p>
                <div
                  draggable
                  id='grabberEnd'
                  className='grabber framerend'
                  style={{
                    left: `${(selectedLabelTab?.frameLabel?.end / videoTiming) * 100
                      }%`,
                    background: frameViewColor,
                  }}
                  onDragEnd={(event) => {
                    handleMouseMoveWhenGrabbed(event, "end");
                  }}
                >
                  {"]"}
                </div>
              </div>
            </div>
            <div
              className='seekable'
              style={{ background: "rgb(203, 235, 250)" }}
              onClick={(e) => updateProgress(e, true)}
            ></div>
            <div className='progress'></div>
          </div> */}
            {isFrameEnabled && (
              <SelectedTimeFrame
                selectedLabelTab={selectedLabelTab}
                timing1={[0.0, ...timeFrameLimit, ...timing1]}
                key={
                  selectedLabelTab.frameLabel.end -
                  selectedLabelTab.frameLabel.start +
                  selectedLabelTab.frameLabel.accindex +
                  selectedLabelTab.frameLabel.timingindx
                }
                n={timing1.length + frameCount}
                currentVideoPlayTime={currentVideoPlayTime}
                getTimeandFrame={getTimeandFrame}
                updateProgress={updateProgress}
                scrollBarRef={scrollBarRef}
                frameCount={frameCount}
                frameTimeLimit={frameTimeLimit}
                sublabelTimings={sublabelTimings}
              />
            )}
            <hr
              className='seperatorLine'
              style={{ width: window.screen.availWidth * 0.7 }}
            />
            {/* {isGetFrameChecked ? (
            frames?.length > 0 ? (
              <div className='output'>
                {frames.map((frame, index) => (
                  <img
                    className='framesImgViewer'
                    onClick={(e) => handleClick(e, frame.imgUrl, index)}
                    key={`vodeo_frames_${index}`}
                    src={frame.imgUrl}
                    alt=''
                  />
                ))}
              </div>
            ) : (
              <p className='output'>loading....</p>
            )
          ) : (
            ""
          )} */}

            <div
              id='videannotateLabelsTimerView'
              className='videoAnnotateLabelContainer'
              style={{ width: playbackLength + 45, height: `${70}px` }}
              onScroll={handleScrollFirst}
              ref={firstDivRef}
            >
              <div
                className={`playback playbackMarkedItems`}
                onClick={updateProgress}
                key={"labeks_bar"}
                style={{
                  width: playbackLength,
                  marginTop: `${window.screen.availHeight < 850 ? "36px" : "60px"
                    }`,
                }}
              >
                {sublabelTimings &&
                  sublabelTimings.map(
                    (sibling, accindex) =>
                      [
                        ...filteredSublabelTimings.map(
                          (sibling1) => sibling1.subname
                        ),
                      ].includes(sibling.subname) && (
                        <>
                          {playVideoRef?.current
                            ? sibling?.timings.map((timing, index) => (
                              <div key={index}>
                                <div key={"grabber_" + index}>
                                  {/* <Tooltip
                                      title={sublabelTimings[accindex]?.subname}
                                      arrow
                                      placement='top'
                                      classes={{
                                        tooltip: "customTooltip", // Add custom styling class
                                      }}
                                    > */}
                                  <div
                                    draggable
                                    id='grabberStart'
                                    className={`start ${accindex == editableInp.accindex &&
                                      index == editableInp.timingindx &&
                                      editableInp.currentGrabbed == "start"
                                      ? "inputOpenedTab"
                                      : accindex ==
                                        selectedLabelTab?.accindex &&
                                        index ==
                                        selectedLabelTab?.timingindx
                                        ? "currentSelectedTab"
                                        : "grabber"
                                      }`}
                                    style={{
                                      left: `${(timing.start / videoTiming) * 100
                                        }%`,
                                      background:
                                        accindex ==
                                          selectedLabelTab?.accindex &&
                                          index ==
                                          selectedLabelTab?.timingindx
                                          ? selectedLabelTab.currentGrabbed ==
                                            "start"
                                            ? "green"
                                            : "black"
                                          : grabberColors[accindex],
                                      zIndex:
                                        accindex ==
                                        selectedLabelTab.accindex &&
                                        index ==
                                        selectedLabelTab.timingindx &&
                                        "100 !important",
                                    }}
                                    onClick={() =>
                                      onSelectSublabel(
                                        accindex,
                                        index,
                                        "start"
                                      )
                                    }
                                    onDragStart={(event) => {
                                      // startDrag(event)
                                      handleMouseMoveWhenGrabbed(
                                        event,
                                        accindex,
                                        index,
                                        "start"
                                      );
                                    }}
                                    // onDrag={(event) => {
                                    //   handleDragging(event); // <-- scroll here
                                    // }}
                                    onDragEnd={(event) => {
                                      // endDrag(event)
                                      handleMouseMoveWhenGrabbed(
                                        event,
                                        accindex,
                                        index,
                                        "start"
                                      );
                                    }}
                                  >
                                    {"["}
                                    {accindex == editableInp.accindex &&
                                      index == editableInp.timingindx &&
                                      editableInp.currentGrabbed ==
                                      "start" ? (
                                      <input
                                        value={editableInp.currentValue}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          editableOnchangeHandler(e);
                                        }}
                                        onKeyDown={handleKeyDown}
                                        className='hmsframeInput hmsframeInputLeft'
                                      />
                                    ) : (
                                      <p
                                        className='frameTimeLines'
                                        style={{
                                          color: grabberColors[accindex],
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setEditableInp({
                                            accindex: accindex,
                                            timingindx: index,
                                            currentGrabbed: "start",
                                            currentValue: getTimeandFrame(
                                              sublabelTimings[accindex]
                                                ?.timings[index].start
                                            ),
                                          });
                                        }}
                                      >
                                        {getTimeandFrame(
                                          sublabelTimings[accindex]
                                            ?.timings[index].start
                                        )}
                                      </p>
                                    )}
                                  </div>
                                  {/* </Tooltip> */}
                                  <Tooltip
                                    title={sublabelTimings[accindex]?.subname}
                                    arrow
                                    placement='top'
                                    classes={{
                                      tooltip: "customTooltip", // Add custom styling class
                                    }}
                                  >
                                    <p
                                      draggable
                                      className={`labelFrames ${index == selectedLabelTab?.timingindx
                                        ? "selectedmarkerContainer"
                                        : "markerContainer"
                                        }`}
                                      onClick={() =>
                                        onSelectSublabel(
                                          accindex,
                                          index,
                                          "start",
                                          true
                                        )
                                      }
                                      style={{
                                        background:
                                          selectedLabelTab?.accindex ==
                                            accindex &&
                                            selectedLabelTab?.timingindx ==
                                            index
                                            ? "repeating-linear-gradient(135deg,#fff,#fff 5px,gray 5px,gray 10px)"
                                            : grabberColors[accindex],
                                        left: `${(timing.start / videoTiming) * 100
                                          }%`,
                                        width: `${(timing?.end / videoTiming) * 100 -
                                          (timing.start / videoTiming) * 100
                                          }%`,
                                        top: "0px",
                                        scale: 1,
                                        position: "absolute",
                                        transform: "translateY(-50%)",
                                        marginTop:
                                          selectedLabelTab?.accindex ==
                                            accindex &&
                                            selectedLabelTab?.timingindx ==
                                            index
                                            ? "0px"
                                            : "1px",
                                        zIndex:
                                          selectedLabelTab?.accindex ==
                                            accindex &&
                                            selectedLabelTab?.timingindx ==
                                            index
                                            ? 5
                                            : 3,
                                      }}
                                      onDragStart={startDrag}
                                      onDrag={(event) => {
                                        handleDragging(event); // <-- scroll here
                                      }}
                                      onDragEnd={(event) => {
                                        endDrag(event);
                                        handleMouseMoveWhenGrabbed(
                                          event,
                                          accindex,
                                          index,
                                          "complete"
                                        );
                                      }}
                                    >
                                      {index ==
                                        selectedLabelTab?.timingindx &&
                                        accindex ==
                                        selectedLabelTab?.accindex && (
                                          <button
                                            className='play-control labelplaypauseControler'
                                            title='Play/Pause'
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              playVideoRef.current.currentTime =
                                                playVideoRef.current
                                                  .currentTime >=
                                                  selectedLabelTab?.start &&
                                                  playVideoRef.current
                                                    .currentTime <=
                                                  selectedLabelTab?.end
                                                  ? playVideoRef.current
                                                    .currentTime
                                                  : selectedLabelTab?.start;
                                              roiDrawRef.current.currentTime =
                                                playVideoRef.current
                                                  .currentTime >=
                                                  selectedLabelTab?.start &&
                                                  playVideoRef.current
                                                    .currentTime <=
                                                  selectedLabelTab?.end
                                                  ? playVideoRef.current
                                                    .currentTime
                                                  : selectedLabelTab?.start;
                                              labelPlayPauseController(
                                                e,
                                                accindex,
                                                index,
                                                true
                                              );
                                            }}
                                          >
                                            {index ==
                                              currentPlayFrame?.timingindx &&
                                              accindex ==
                                              currentPlayFrame?.accindex ? (
                                              playing ? (
                                                <FontAwesomeIcon
                                                  icon={faPause}
                                                />
                                              ) : (
                                                <FontAwesomeIcon
                                                  icon={faPlay}
                                                />
                                              )
                                            ) : (
                                              <FontAwesomeIcon
                                                icon={faPlay}
                                              />
                                            )}
                                          </button>
                                        )}
                                    </p>
                                  </Tooltip>
                                  {/* Markup and logic for the end trim marker */}
                                  {/* <Tooltip
                                      title={sublabelTimings[accindex]?.subname}
                                      arrow
                                      placement='top'
                                      classes={{
                                        tooltip: "customTooltip", // Add custom styling class
                                      }}
                                    > */}
                                  <div
                                    draggable
                                    id='grabberEnd'
                                    className={`end ${accindex == editableInp.accindex &&
                                      index == editableInp.timingindx &&
                                      editableInp.currentGrabbed == "end"
                                      ? "inputOpenedTab"
                                      : accindex ==
                                        selectedLabelTab?.accindex &&
                                        index ==
                                        selectedLabelTab?.timingindx
                                        ? "currentSelectedTab"
                                        : "grabber"
                                      }`}
                                    style={{
                                      left: `${(timing?.end / videoTiming) * 100
                                        }%`,
                                      background:
                                        accindex ==
                                          selectedLabelTab?.accindex &&
                                          index ==
                                          selectedLabelTab?.timingindx
                                          ? selectedLabelTab?.currentGrabbed ==
                                            "end"
                                            ? "green"
                                            : "black"
                                          : grabberColors[accindex],
                                    }}
                                    onClick={() =>
                                      onSelectSublabel(
                                        accindex,
                                        index,
                                        "end"
                                      )
                                    }
                                    onDragStart={(event) => {
                                      // startDrag(event)
                                      handleMouseMoveWhenGrabbed(
                                        event,
                                        accindex,
                                        index,
                                        "end"
                                      );
                                    }}
                                    // onDrag={(event) => {
                                    //   handleDragging(event); // <-- scroll here
                                    // }}
                                    onDragEnd={(event) => {
                                      // endDrag(event)
                                      handleMouseMoveWhenGrabbed(
                                        event,
                                        accindex,
                                        index,
                                        "end"
                                      );
                                    }}
                                  >
                                    {"]"}
                                    {accindex == editableInp.accindex &&
                                      index == editableInp.timingindx &&
                                      editableInp.currentGrabbed == "end" ? (
                                      <input
                                        value={editableInp.currentValue}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          editableOnchangeHandler(e);
                                        }}
                                        onKeyDown={handleKeyDown}
                                        className='hmsframeInput hmsframeInputRight'
                                      />
                                    ) : (
                                      <p
                                        className='frameTimeLinesright'
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setEditableInp({
                                            accindex: accindex,
                                            timingindx: index,
                                            currentGrabbed: "end",
                                            currentValue: getTimeandFrame(
                                              sublabelTimings[accindex]
                                                ?.timings[index].end
                                            ),
                                          });
                                        }}
                                        style={{
                                          color: grabberColors[accindex],
                                        }}
                                      >
                                        {getTimeandFrame(
                                          sublabelTimings[accindex]
                                            ?.timings[index].end
                                        )}
                                      </p>
                                    )}
                                  </div>
                                  {/* </Tooltip> */}
                                </div>
                              </div>
                            ))
                            : []}
                          <div
                            className='seekable'
                            onClick={updateProgress}
                          // onContextMenu={(e) => {
                          //               e.preventDefault();
                          //               setContextMenu({ x: e.clientX, y: e.clientY-150, accindex });
                          //             }}
                          ></div>
                          <div className='progress'></div>
                        </>
                      )
                  )}
                <div className='timingcontainer'>
                  <FrameTime
                    timing1={timing1}
                    n={timeEnd}
                    playbackLength={playbackLength}
                    hms={getTimeandFrame}
                    frameCount={frameCount}
                    frameTimeLimit={frameTimeLimit ? frameTimeLimit : 0}
                  />
                </div>
              </div>
            </div>
            {activeAction && activeAction in ["edit"] && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0,0,0,0.3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                }}
                onClick={() => setActiveAction(null)}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    minWidth: "300px",
                  }}
                >
                  <h3>{activeAction} Timing</h3>
                  <label>Start Time (comma separated):</label>
                  <input
                    type='text'
                    value={timingInput.start}
                    onChange={(e) =>
                      setTimingInput({ ...timingInput, start: e.target.value })
                    }
                    style={{ width: "100%", marginBottom: "10px" }}
                  />
                  <label>End Time (comma separated):</label>
                  <input
                    type='text'
                    value={timingInput.end}
                    onChange={(e) =>
                      setTimingInput({ ...timingInput, end: e.target.value })
                    }
                    style={{ width: "100%", marginBottom: "10px" }}
                  />
                  <div style={{ textAlign: "right" }}>
                    <button
                      onClick={() => {
                        setActiveAction(null);
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
            {contextMenu && contextMenu.accindex != -1 && (
              <ul
                style={{
                  position: "fixed",
                  top: contextMenu.y,
                  left: contextMenu.x,
                  zIndex: 9999,
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                  borderRadius: "6px",
                  padding: "4px 0",
                  listStyle: "none",
                  minWidth: "120px",
                }}
                onMouseLeave={() => setContextMenu(null)}
              >
                {["add"].map((action) => (
                  <li
                    key={action}
                    onClick={() => {
                      handleRightClickEvent(action);
                    }}
                    style={{
                      padding: "6px 12px",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#f0f0f0")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "transparent")
                    }
                  >
                    {action}
                  </li>
                ))}
              </ul>
            )}
            <div className='annotatesubmitcontainer'>
              <AlertMessageBox
                showAlertBox={showAlertBox}
                setShowAlertBox={setShowAlertBox}
                alertMessage={alertMessage}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={openChartData}
        onClose={handleCloseChartData}
        aria-labelledby='child-modal-title'
        aria-describedby='child-modal-description'
        style={{ background: "none" }}
        className='ContainerForChartDataModal'
      >
        <Box
          sx={{
            ...modalStyle,
            width: 350,
            top: "45%",
            height: "auto",
            padding: "20px",
          }}
        >
          <div>
            <ExportChartData
              rows={[
                ["Total no of Frames", `${videoTiming * frameCount}`],
                ["Mean", `${analyticData?.mean}`],
                ["Median", `${analyticData?.median}`],
                ["Min", `${analyticData?.min}`],
                ["Max", `${analyticData?.max}`],
              ]}
            />
          </div>
        </Box>
      </Modal>
      <Modal
        open={openlabelSelector}
        onClose={handleCloseLabelSelector}
        aria-labelledby='child-modal-title'
        aria-describedby='child-modal-description'
        style={{ background: "none" }}
        className='ContainerForTheAnnoatatorModal'
      >
        <Box
          sx={{
            ...modalStyle,
            width: 350,
            top:
              modalType == "shortcuts"
                ? "16%"
                : // : modalType == 'roi' ? '63%'
                "45%",
          }}
          className='modal-box'
        >
          <FontAwesomeIcon
            icon={faTimes}
            className='close-icon'
            onClick={handleCloseLabelSelector}
          />
          {modalType == "shortcuts" ? (
            <div className='alertMessage-for-shortcuts'>
              <h4>ShortCuts</h4>
              <div>
                {shortCutsList.map((shortcut, index) => (
                  <li key={`shortCutKeys${index}`}>
                    <span>{shortcut.key}</span>=
                    <span style={{ color: "green" }}>{shortcut.event}</span>
                  </li>
                ))}
              </div>
            </div>
          ) : modalType == "roi" ? (
            <div className='containerForRoiModal'>
              <MeasurementsModal
                measurements={measurements}
                setMeasurements={setMeasurements}
                handleSubmitMeasurements={handleSubmitMeasurements}
                setAlertMessage={setAlertMessage}
                openAlertPopup={openAlertPopup}
                visibleVideoDimensions={visibleVideoDimensions}
                showCroppedVideo={showCroppedVideo}
                enableROI={enableROI}
                selecteROIindex={selecteROIindex}
                roiList={roiList}
                selectedEditableROIindex={selectedEditableROIindex}
              />
            </div>
          ) : modalType == "select_roi" ? (
            <>
              <div>
                <h4 className='frame_export_header'>Select Label</h4>
                <select
                  value={selecteROIindex}
                  onChange={roiOnChangeHandler}
                  className='modal-dropdown'
                  disabled={enableROI}
                  style={{
                    cursor: enableROI ? "not-allowed" : "pointer",
                    visibility: enableROI ? "hidden" : "visible",
                  }}
                >
                  {roiList.map((label, index) => (
                    <option key={`labels_option_${index}`} value={index}>
                      {index === 0
                        ? "Full Video"
                        : roiList[index]?.label ? roiList[index]?.label : `ROI ${roiList[index]?.roi_id}`}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : modalType == "select_labels" ? (
            <>
              <div>
                <h4 className='frame_export_header'>Select Label</h4>
                <select
                  value={currentlabel}
                  onChange={(e) =>
                    onchangeHandlerLabel(e.target.value, sublabelTimings)
                  }
                  className='modal-dropdown'
                >
                  {labelsLi.map((label, index) => (
                    <option key={`labels_option_${index}`} value={label}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : modalType == "edit_frame_arrow_controll" ? (
            <div className='alertMessage'>
              <h4 className='frame_export_header'>
                Please Enter the Frame Interval
              </h4>
              <div className='frame_export_inp_container'>
                    <input
                      className='frame_interval_input'
                      type='number'
                      value={frameIntervalControll}
                      onChange={(e) =>
                        /[0-9]*/.test(e.target.value) &&
                        parseInt(e.target.value) > 0 &&
                        parseInt(e.target.value) <= frameCount &&
                        setFrameIntervalControll(e.target.value)
                      }
                    />
                    <button
                      className='frame_download_submit_button'
                      onClick={() => {
                        setArrowIntervalControll(frameIntervalControll)
                        setAlertMessage({
                          Errortype: "Success",
                          title: "Success",
                          message: 'Arrow control updated successfully',
                        });
                        openAlertPopup();
                        handleCloseLabelSelector();
                      }}
                    >
                      Update Arrow Control
                    </button>
              </div>
            </div>
          ) : modalType == "export_frames" ? (
            <div className='alertMessage'>
              <h4 className='frame_export_header'>
                Please enter the frame interval for Arrow control
              </h4>
              <div className='frame_export_inp_container'>
                {exportFrameLoader ? (
                  <div className='frame_download_loader'>
                    {" "}
                    <GradientCircularProgress />
                  </div>
                ) : (
                  <>
                    <input
                      className='frame_interval_input'
                      type='number'
                      value={frameInterval}
                      onChange={(e) =>
                        /[0-9]*/.test(e.target.value) &&
                        parseInt(e.target.value) > 0 &&
                        parseInt(e.target.value) <= frameCount &&
                        setFrameInterval(e.target.value)
                      }
                    />
                    <button
                      className='frame_download_submit_button'
                      onClick={handleDownloadVideoFrames}
                    >
                      <FontAwesomeIcon icon={faDownload} /> Download Video
                      Frames
                    </button>
                  </>
                )}
              </div>
            </div>
          ) : modalType == "add_new_label" ? (
            <>
              <div>
                <h4 className='frame_export_header'>Select Label</h4>
                <LabelDropdown
                  sublabelTimings={sublabelTimings}
                  filteredSublabelTimings={filteredSublabelTimings}
                  addExtramargins={addExtramargins}
                  handleCloseLabelSelector={handleCloseLabelSelector}
                />
              </div>
            </>
          )
            : modalType == "labelsInfo" ? (
              <div className='frame_export_header'>
                <h4>Labels Information <div className="labels-key-information"><b>Keys</b>: Only <b>alphanumeric</b> characters are allowed<div> alphanumeric not allowed characters: <b>0,c,f,s,v,x,z</b></div></div></h4>
                <div className='labels-info-container'>
                  {collectionLabelset.map((label, index) => (
                    <>
                      {label?.labelSetName == currentlabel ?
                        <table className="sublabel-table" key={`label-table-${index}`}>
                          <thead>
                            <tr>
                              <th className='left-cells'>Label</th>
                              <th className='left-cells'>Key <i className="text-primary text-decoration-underline cursor-pointer" onClick={handleEnableEditLabels}>(edit all keys)</i></th>
                              <th className='right-cells'>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(labelsetsAccessKeys).length > 0 && label.labels.map((sublabel, index1) => (
                              <tr key={`label${index}sublabels${index1}`}>
                                <td className='left-cells' title={sublabel.labelName}>{sublabel.labelName}</td>
                                <td className='left-cells' style={{ width: '150px' }} title={labelsetsAccessKeys[sublabel.labelName]?.labelAccessKey}>
                                  {labelsetsAccessKeys[sublabel.labelName].enableEdit || enableLabelEdit ?
                                    <div className="d-flex">
                                      <input value={labelsetsAccessKeys[sublabel.labelName]?.labelAccessKey} onChange={(e) => handleKeyChange(e, sublabel.labelName)} 
                                      onKeyDown={(event) => event.key=="Enter" && handleSaveAccessKey(sublabel, label)}
                                       className="access-key-input" />
                                      {label.labels.map((label, index1) => (
                                        label.labelName != sublabel.labelName && labelsetsAccessKeys[label.labelName].labelAccessKey.length != 0 && labelsetsAccessKeys[label.labelName].labelAccessKey.toLowerCase() == labelsetsAccessKeys[sublabel.labelName]?.labelAccessKey.toLowerCase() ?
                                          <p key={`keys-list-${index1}`} className="text-danger m-1">Key used!!!</p> : ''
                                      ))}

                                      {enableLabelEdit ? '' : <><FontAwesomeIcon icon={faCheckCircle} onClick={() => handleSaveAccessKey(sublabel, label)} className="mt-1 cursor-pointer text-success mx-2 mt-1 access-key-controll" />
                                        <FontAwesomeIcon icon={faTimesCircle} onClick={() => handleDisableEdit(sublabel.labelName)} className="mt-1 cursor-pointer text-success mx-2 text-danger mt-1 access-key-controll" /></>}
                                    </div> :
                                    <div className="d-flex">
                                      <p className="m-1">{labelsetsAccessKeys[sublabel.labelName]?.labelAccessKey}</p>
                                      <FontAwesomeIcon icon={faPencilAlt} onClick={() => handleEnableEdit(sublabel.labelName)} className="mt-1 cursor-pointer" />
                                    </div>
                                  }
                                </td>
                                <td className='right-cells' title={sublabel.labelDescription}>{sublabel.labelDescription || 'No description'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table> : ''}
                    </>
                  ))}
                  {enableLabelEdit &&
                    <div className="d-flex justify-content-center">
                      <button className="btn btn-sm btn-primary m-2" style={{ width: '50%' }} onClick={handleSubmitAllKeys} type="submit">Submit</button>
                      <button className="btn btn-sm btn-danger m-2" style={{ width: '50%' }} onClick={handleDisableEditLabels} type="submit">Cancel</button>
                    </div>}
                </div>
              </div>
            )
              : (
                <>
                  <div>
                    <div className='alertMessage'>
                      <h4>Visible SubLabels</h4>
                    </div>
                    <Stack spacing={3} sx={{ width: "96%" }}>
                      <Autocomplete
                        multiple
                        style={{
                          marginTop: `${window.screen.availHeight < 850 ? "4.5%" : "8%"
                            }`,
                          marginLeft: "2%",
                          height: "100px",
                          paddingTop: "7px",
                          overflowY: "auto",
                        }}
                        id={"autocomplete_with_select_all"}
                        fullWidth
                        options={sublabelTimings}
                        getOptionLabel={(sibling) => sibling.subname}
                        defaultValue={filteredSublabelTimings}
                        value={filteredSublabelTimings}
                        selectOnFocus={false}
                        freeSolo={false}
                        onChange={(_e, value, reason) => {
                          if (reason === "clear" || reason === "removeOption")
                            setSelectAll(false);
                          if (
                            reason === "selectOption" &&
                            value.length === sublabelTimings.length
                          )
                            setSelectAll(true);
                          setfilteredSublabelTimings(value);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label={"SubLabels"} />
                        )}
                        PaperComponent={(paperProps) => {
                          const { children, ...restPaperProps } = paperProps;
                          return (
                            <Paper
                              {...restPaperProps}
                              style={{ padding: "0px 16px", marginTop: "0px" }}
                            >
                              <Box
                                onMouseDown={(e) => e.preventDefault()} // prevent blur
                                pl={1.5}
                                py={0.5}
                              >
                                <FormControlLabel
                                  onClick={(e) => {
                                    e.preventDefault(); // prevent blur
                                    handleToggleSelectAll();
                                  }}
                                  style={{
                                    padding: "0px",
                                    marginTop: "0px",
                                    background: "none",
                                    color: "black",
                                    width: "100%",
                                  }}
                                  label='Select all'
                                  control={
                                    <Checkbox
                                      id='select-all-checkbox'
                                      checked={selectAll}
                                    />
                                  }
                                />
                              </Box>
                              <Divider />
                              {children}
                            </Paper>
                          );
                        }}
                        clearOnEscape={true}
                        disableCloseOnSelect={true}
                      />
                    </Stack>
                  </div>
                </>
              )}
        </Box>
      </Modal>
    </div>
  );
}
